{
    "buyer": {
        "avaliacoes": {
            "avaliacao": {
                "negativa": "Não",
                "positiva": "Sim"
            },
            "cabecalho": {
                "avaliacao": "Gostou do Atendimento?",
                "cashback": "Cashback",
                "opcao": "Avaliar ou Ignorar",
                "pedido": "Pedido",
                "veiculo": "Veículo",
                "vendedor": "Vendedor (Empresa)"
            },
            "mensagens": {
                "erro": {
                    "avaliar": {
                        "corpo": "Não foi possível realizar esta avaliação",
                        "titulo": "Erro!"
                    },
                    "carregamento": {
                        "corpo": "Não foi possível listar as suas avaliações",
                        "titulo": "Erro!"
                    }
                },
                "sucesso": {
                    "avaliar": {
                        "corpo": "Avaliação realizada",
                        "titulo": "Sucesso!"
                    }
                }
            },
            "motivo": {
                "opcional": "Opcional",
                "titulo": "Explique em poucas palavras o motivo de sua avaliação"
            },
            "opcao": {
                "avaliar": "Avaliar",
                "nao-avaliar": "Ignorar",
                "pendente": "Pendente"
            },
            "situacao": {
                "ignorada": "Ignorada",
                "negativa": "Negativa",
                "positiva": "Positiva"
            },
            "titulo": {
                "ja-realizadas": "Últimas 15 avaliações feitas",
                "nao-realizadas": "Defina se o atendimento do vendedor foi bom ou ruim (Avaliações pendentes)",
                "tela": "Acompanhe suas avaliações de pedidos"
            },
            "vazio": {
                "ja-realizadas": "Você ainda não realizou nenhuma avaliação",
                "nao-realizadas": "Não há nenhuma avaliação pendente"
            }
        },
        "cashback": {
            "menu": {
                "p1": "Você tem",
                "p2": "acumulados de cashback"
            },
            "modal": {
                "corpo": {
                    "duvidas": "Em caso de dúvida entrar em contato com suporte@partsfy.com.br.",
                    "email": "E-mail",
                    "gestor": "Gestor",
                    "realize-compras": "Receba mais cashback ao comprar com fornecedores homologados!",
                    "somente-gestor": "Somente o responsável por sua conta poderá solicitar este resgate"
                },
                "legend": {
                    "disponivel": "Valor disponível",
                    "minimo-saque": "Valor mínimo para saque"
                },
                "titulo": "Resgate seu cashback até "
            }
        },
        "condicoes": {
            "compradas": {
                "titulo": "Condições Escolhidas",
                "vazio": "Não houve compra nesta cotação"
            },
            "mensagens": {
                "listar": {
                    "erro": {
                        "nao-encontrado": "Pedido não encontrado",
                        "titulo": "Erro!"
                    }
                }
            },
            "nao-compradas": {
                "titulo": "Lista de Condições",
                "vazio": "Todas as opções foram compradas"
            },
            "resposta": {
                "pecas": {
                    "desconto": "Desc",
                    "melhor-prazo": {
                        "bo": "Melhor Prazo em BO",
                        "pe": "Melhor Prazo em Estoque",
                        "pf": "Melhor Prazo em Pedido de Fábrica"
                    },
                    "melhor-preco": "Melhor Preço",
                    "nome": "Peça",
                    "marca": "Marca",
                    "prazo": {
                        "label": "Prazo",
                        "tooltip": "Prazo Entrega em Dias Úteis"
                    },
                    "quantidade": "Qt",
                    "total": "Total",
                    "valor": "Vlr Unit",
                    "valor-cia": {
                        "label": "Vlr Cia",
                        "sem-info": "Sem Info"
                    }
                }
            },
            "seguradora": "Seguradora"
        },
        "convidar": {
            "dados-convite": {
                "empresa": {
                    "label": "Empresa",
                    "obrigatorio": "A empresa do vendedor é obrigatório"
                },
                "nome": {
                    "label": "Nome",
                    "obrigatorio": "O nome do vendedor é obrigatório"
                },
                "email": {
                    "label": "E-mail",
                    "obrigatorio": "O e-mail do vendedor é obrigatório",
                    "formato-invalido": "Formato do e-mail inválido"
                },
                "telefone": {
                    "label": "Telefone",
                    "obrigatorio": "O telefone do vendedor é obrigatório",
                    "formato-invalido": "Formato do telefone inválido"
                },
                "whatsapp": {
                    "label": "Whats App",
                    "obrigatorio": "O Whats App do vendedor é obrigatório",
                    "formato-invalido": "Formato do Whats App inválido"
                },
                "botoes": {
                    "cancelar": "Cancelar",
                    "convidar": "Enviar Convite"
                }
            },
            "titulo": "Convidar Vendedor"
        },
        "convites": {
            "botoes": {
                "arquivar": {
                    "titulo": "Arquivar Convite"
                },
                "editar": {
                    "titulo": "Editar Convite"
                },
                "reenviar": {
                    "titulo": "Reenviar Convite"
                }
            },
            "listagem": {
                "vazio": "Nenhum convite foi encontrado",
                "colunas": {
                    "oficina": {
                        "titulo": "Oficina"
                    },
                    "comprador": {
                        "titulo": "Comprador"
                    },
                    "data-convite": {
                        "titulo": "Data Convite"
                    },
                    "fornecedor": {
                        "titulo": "Fornecedor"
                    },
                    "vendedor": {
                        "titulo": "Vendedor"
                    },
                    "email": {
                        "titulo": "E-mail"
                    },
                    "fone-radio": {
                        "titulo": "Fone / Whats App"
                    }
                }
            },
            "mensagens": {
                "sucesso": {
                    "titulo": "Salvo com sucesso",
                    "titulo-envio": "Enviado com sucesso",
                    "corpo": "Operação realizada com sucesso."
                },
                "erro": {
                    "titulo": "Erro ao salvar",
                    "corpo": "Ocorreu um erro ao salvar."
                },
                "email-existente": {
                    "titulo": "E-mail não disponível",
                    "corpo": "Já existe outro usuário com o e-mail informado."
                }
            },
            "textbox": {
                "pesquisa": {
                    "placeholder": "Procure pela empresa, nome, e-mail, etc."
                }
            },
            "vendedores-convidados": {
                "titulo": "Acompanhar Vendedores Convidados",
                "apenas_nao_aceitos": "Listar apenas convites não aceitos"
            }
        },
        "convidados": {
            "titulo": "Acompanhar Vendedores Convidados",
            "vazio": "Nenhum convite foi encontrado",
            "pesquisar": {
                "label": "Pesquisar",
                "placeholder": "Pesquise pela Empresa, Nome ou Email",
                "filtro": "Listar apenas convites não aceitos"
            },
            "dados-convite": {
                "aceito": "Convite Aceito",
                "aguardando": "Aguardando"
            },
            "dados-vendedor": {
                "email": "E-mail",
                "fone-radio": "Fone / Whats App",
                "ultimo-convite": "Último Convite"
            },
            "botao": {
                "fechar": "Fechar",
                "cancelar": "Cancelar",
                "reenviar": "Reenviar Convite",
                "excluir": "Excluir Convite"
            },
            "confirmacao": {
                "reenviar": "Deseja realmente reenviar este convite?",
                "excluir": "Deseja realmente remover este convite?",
                "ultimo-convite": "O último convite enviado foi em:"
            },
            "mensagens": {
                "reenviar": {
                    "sucesso": {
                        "titulo": "Convite reenviado",
                        "corpo": "Operação realizada com sucesso"
                    }
                },
                "excluir": {
                    "sucesso": {
                        "titulo": "Convite removido",
                        "corpo": "Operação realizada com sucesso"
                    }
                }
            }
        },
        "cotacao": {
            "mensagens": {
                "adicionar-vendedor-externo": {
                    "confirmacao": {
                        "titulo": "Você deseja responder pelo vendedor externo ou enviar o link para ele por Whatsapp?",
                        "enviar-mensagem": "Enviar link por whatsapp",
                        "responder-pelo-vendedor-externo": "Responder pelo vendedor"
                    }
                },
                "alterar": {
                    "erro": {
                        "dados-invalidos": {
                            "titulo": "Ocorreu um erro",
                            "corpo": {
                                "delivery-time-id": "Prazo de entrega da peça <{0}> está inválido",
                                "item-answer-id": "O código da peça <{0}> está inválido",
                                "price": "O preço da peça <{0}> deve ser maior do que zero"
                            }
                        },
                        "salvar": {
                            "titulo": "Ops",
                            "corpo": "Ocorreu um erro ao tentar alterar os dados desta cotação"
                        }
                    },
                    "sucesso": {
                        "salvar": {
                            "titulo": "Sucesso!",
                            "corpo": "Dados alterados com sucesso!"
                        }
                    }
                },
                "comprar": {
                    "sucesso": {
                        "titulo": "Sucesso!",
                        "corpo": "Compra Efetuada"
                    }
                },
                "comprar-api": {
                    "sucesso": {
                        "titulo": "Sucesso!",
                        "corpo": "Compra Enviada via API"
                    }
                },
                "erro": {
                    "titulo": "Ocorreu um erro",
                    "corpo": "Operação não realizada"
                },
                "listar": {
                    "erro": {
                        "titulo": "Cotação Não Encontrada",
                        "nao-encontrada": "A cotação #xxx não foi encontrada ou já se tornou um pedido.",
                        "sem-codigo": "O código desta cotação está inválido."
                    }
                },
                "reabrir": {
                    "sucesso": {
                        "titulo": "Cotação Re-aberta",
                        "corpo": "Operação realizada com sucesso"
                    }
                },
                "salvar-cache": {
                    "erro": {
                        "corpo": "Não foi possível {type} esta seleção",
                        "titulo": "Erro!"
                    },
                    "sucesso": {
                        "corpo": "Peças selecionadas {type}s com sucesso",
                        "titulo": "Sucesso!"
                    },
                    "tipo":{
                        "liberada": "liberada",
                        "liberar": "liberar",
                        "salva": "salva",
                        "salvar": "salvar"
                    }
                }
            },
            "sidebar": {
                "botao": {
                    "abrir": "Nova Cotação",
                    "excluir": {
                        "titulo": "Excluir Cotação",
                        "mensagens": {
                            "nenhuma-cotacao-selecionada": "É necessário selecionar uma cotação",
                            "erro": "Houve um erro ao tentar excluir esta cotação.<br />Aguarde e tente novamente mais tarde"
                        }
                    },
                    "reabrir": {
                        "erro": "Houve um erro ao tentar reabrir esta cotação.<br />Aguarde e tente novamente mais tarde"
                    }
                },
                "pesquisa": {
                    "titulo": "Busca",
                    "textbox": {
                        "placeholder": "Busca Veículo/Placa/Marca"
                    }
                },
                "abrir-cotacao": {
                    "titulo": "Nova Cotação",
                    "mensagens": {
                        "sucesso": {
                            "titulo": "Salvo com sucesso"
                        },
                        "erro-upload_foto": {
                            "titulo": "Atenção"
                        },
                        "erro": "Houve um erro ao tentar realizar o cadastro.<br />Aguarde e tente novamente mais tarde"
                    },
                    "botao": {
                        "audatex_soma": {
                            "label": "Importar Audatex ou Soma",
                            "sucesso": {
                                "titulo": "Upload com sucesso",
                                "corpo": "Dados importados com sucesso"
                            }
                        },
                        "salvar": "Solicitar Nova Cotação",
                        "cancelar": "Cancelar"
                    },
                    "ano": {
                        "label": "Ano",
                        "obrigatorio": "O ano do veículo é obrigatório",
                        "min-max": "Entre {0} e {1}"
                    },
                    "chassi": {
                        "label": "Chassi",
                        "obrigatorio": "O chassi do veículo é obrigatório",
                        "formato-invalido": "Formato chassi inválido"
                    },
                    "marca": {
                        "label": "Marca",
                        "placeholder": "Selecione a marca",
                        "obrigatorio": "A marca do veículo é obrigatória"
                    },
                    "placa": {
                        "label": "Placa",
                        "obrigatorio": "A placa do veículo é obrigatório",
                        "formato-invalido": "Formato placa inválido"
                    },
                    "seguradora": {
                        "label": "Seguradora",
                        "placeholder": "Selecione seguradora",
                        "obrigatorio": "A seguradora é obrigatória"
                    },
                    "veiculo": {
                        "label": "Veículo",
                        "placeholder": "Digite o veículo e seu modelo",
                        "obrigatorio": "O nome do veículo é obrigatório"
                    },
                    "observacao": {
                        "label": "Observações",
                        "placeholder": "Direção hidráulica, ar condicionado..."
                    },
                    "links": {
                        "observacao": "Inserir Observação",
                        "fotos": "Inserir Fotos"
                    },
                    "pecas": {
                        "obrigatorio": "Ao menos uma peça deve ser cadastrada",
                        "dados": {
                            "descricao": {
                                "label": "Descrição",
                                "placeholder": "Descrição da peça",
                                "obrigatorio": "O nome da peça é obrigatório"
                            },
                            "quantidade": {
                                "label": "Quantidade",
                                "obrigatorio": "Este campo é obrigatório e deve ser maior do que zero"
                            }
                        },
                        "tabela": {
                            "peca": "Peça",
                            "codigo": "Código",
                            "quantidade": "Quantidade",
                            "vazia": "Nenhuma peça foi adicionada"
                        }
                    }
                },
                "excluir-cotacao": {
                    "titulo": "Excluir Cotação",
                    "subtitulo": "Veículo: ",
                    "legenda": "Selecione o motivo da exclusão da cotação",
                    "botao": {
                        "excluir": "Excluir Cotação",
                        "cancelar": "Cancelar"
                    },
                    "comment": {
                        "obrigatorio": "É necessário preencher este campo"
                    },
                    "reasons": {
                        "placeholder": "Selecione o motivo",
                        "obrigatorio": "É necessário selecionar pelo menos um motivo"
                    },
                    "sucesso": {
                        "titulo": "Cotação Excluída",
                        "corpo": "Operação realizada com sucesso"
                    },
                    "enviar-convite": {
                        "titulo": "Enviar Convite",
                        "subtitulo": "Informe os dados do vendedor no formulário abaixo",
                        "botao": {
                            "cancelar": "Cancelar",
                            "enviar": "Enviar Convite"
                        }
                    }
                }
            },
            "area-respostas": {
                "nenhuma-resposta": {
                    "titulo": "ATÉ O MOMENTO NENHUM FORNECEDOR RESPONDEU SUA COTAÇÃO!",
                    "subtitulo": "Os vendedores listados abaixo foram notificados via email de sua nova cotação."
                },
                "alerta": {
                    "total_pe": "Encontramos todas as peças em estoque",
                    "maioria_pe": "Encontramos todas as peças e a maioria em estoque",
                    "maioria_pf": "Encontramos todas as peças e a maioria em Pedido de Fábrica",
                    "vermelho": {
                        "parte1": "Encontramos ",
                        "parte2": "{0} de {1} peças",
                        "parte3": " solicitadas!",
                        "ver": "(Ver peça{2} não encontrada{2})",
                        "titulo": "Lista Não Encontrada"
                    },
                    "aviso": "Aviso!",
                    "resposta_atualizada": {
                        "titulo": "Sucesso",
                        "corpo": "Resposta atualizada"
                    }
                },
                "resposta": {
                    "cabecalho": {
                        "tip-vendedor": {
                            "vendedor": "Vendedor",
                            "email": "E-mail",
                            "fone_radio": "Fone / Whats App",
                            "is-billable": "Fornecedor Homologado",
                            "has-cashback": "Oportunidade de Cashback",
                            "supplier_commission": "Taxa de Comissão (%)"
                        },
                        "tip-motivo-rejeicao": {
                            "buyer": "Este pedido foi previamente cancelado pelo comprador.",
                            "seller": "Este pedido foi previamente rejeitado por este vendedor.",
                            "motivo": " Motivo: "
                        },
                        "tip-nota": {
                            "titulo": "Nota Geral",
                            "subtitulo": "Avaliação geral no últimos 90 dias"
                        },
                        "tip-posicao": {
                            "titulo": "TOP {{position}}!",
                            "subtitulo": "Este vendedor está entre os {{position}} melhores da categoria"
                        },
                        "tip-sales-number-brand": {
                            "titulo": "Vendas",
                            "subtitulo": "Número de vendas na marca {brand}"
                        },
                        "ver-mais": "Ver mais",
                        "top": "TOP "
                    },
                    "editar": {
                        "confirm": "Este fornecedor já tem as condições de fornecimento pré-configuradas. Caso edite o frete não será possível voltar a versão anterior. Deseja prosseguir?",
                        "frete": {
                            "conta-comprador": "A negociar com vendedor",
                            "gratuito": "Gratuito",
                            "titulo": "Frete Gratuito?",
                            "valor": "Defina o valor ou se o comprador deve pagar quando receber:"
                        }
                    },
                    "pecas": {
                        "botoes": {
                            "cancelar": "Cancelar",
                            "salvar": "Salvar"
                        },
                        "cia": "Valor Cia R$",
                        "quantidade": "Qt",
                        "codigo": "Cód",
                        "nome": "Peça",
                        "marca": "Marca",
                        "valor": "Valor Un. R$",
                        "desconto": "Desc",
                        "tipo": "Tipo",
                        "total": "Total",
                        "total-cifrao": "Valor Total R$",
                        "prazo": {
                            "label": "Prazo",
                            "tooltip": "Prazo Entrega em Dias Úteis"
                        },
                        "prazo-dias": "Dias Úteis",
                        "melhor-preco": "Melhor Preço",
                        "melhor-prazo": {
                            "bo": "Melhor Prazo em BO",
                            "pe": "Melhor Prazo em Estoque",
                            "pf": "Melhor Prazo em Pedido de Fábrica"
                        },
                        "peca-estoque": "Peça em Estoque",
                        "pedido-fabrica": "Pedido de Fábrica",
                        "back-order": "BO de Fábrica",
                        "mais-detalhes": {
                            "valor": "Valor",
                            "desconto": "Desconto",
                            "marca": "Marca",
                            "tipo": "Tipo"
                        },
                        "codigo-antigo": {
                            "label": "Código Antigo",
                            "vazio": "&lt;Não Preenchido&gt;"
                        }
                    },
                    "rodape": {
                        "total": "Total (Frete + Peças)",
                        "frete": {
                            "conta-comprador": "A negociar com vendedor",
                            "gratuito": "Gratuito",
                            "label": "Frete",
                            "label-melhor": "Melhor Opção Frete",
                            "nao-entregamos": "Não entregamos"
                        },
                        "total-pecas": "Peças",
                        "limite": "Limite Disponível",
                        "total-frete-pecas": "Total (Frete + Peças)",
                        "faturamento-liberado": "Faturamento Liberado",
                        "faturamento-nao-liberado": "Faturamento Não Liberado",
                        "sem-limite-faturamento": "Sem Limite de Faturamento",
                        "cashback": {
                            "parte-1": "Receba até ",
                            "parte-2": " de Cashback"
                        }
                    },
                    "nao-participando": {
                        "titulo": "O vendedor decidiu não participar da cotação",
                        "motivo": "Motivo"
                    }
                },
                "titulo": "Lista de Condições",
                "modal-avaliacao": {
                    "titulo": "Dados do Vendedor",
                    "informacao-usuario": {
                        "email": "E-mail",
                        "tempo-partsfy": "Tempo de Partsfy",
                        "primeiro-ano-partsfy": "Primeiro ano de Partsfy!",
                        "localizacao": "Localização",
                        "whatsapp":"Whatsapp",
                        "numero-vendas": "Número de Vendas",
                        "top": "TOP "
                    },
                    "label-entrega": "Entregas com sucesso nos últimos 90 dias",
                    "label-score": "Score de participação nos últimos 90 dias",
                    "nota-geral": {
                        "titulo": "Nota Geral",
                        "subtitulo": "Avaliação geral nos últimos 90 dias",
                        "sem-avaliacao": "Sem avaliações"
                    },
                    "avaliacoes": {
                        "titulo": "Avaliações ",
                        "botao": "Mostrar mais avaliações",
                        "sem-avaliacoes": "Vendedor não possui avaliações"
                    },
                    "erro": {
                        "titulo": "Erro!",
                        "abrir": "Erro ao carregar informações sobre o vendedor",
                        "carregar-avaliacoes": "Erro ao carregar mais avaliações"
                    },
                    "tip-score": {
                        "titulo": "Score",
                        "subtitulo": "O score é uma métrica que mede a qualidade e o tempo de resposta às cotações que o vendedor recebe na plataforma"
                    },
                    "tip-all-brands": {
                        "titulo": "Avaliação",
                        "subtitulo": "Avaliações em todas as montadoras"
                    },
                    "tip-sales-number-brand": {
                        "titulo": "Avaliação",
                        "subtitulo": "Avaliações em todas as montadoras"
                    }
                }
            },
            "area-comprar": {
                "adicionar-vendedor-externo": "Adicionar Vendedor Externo",
                "adicionar-complemento": "Adicionar Complemento",
                "botao": {
                    "comprar": "Comprar",
                    "via-api": "Enviar API",
                    "via-api-enviado": "Enviar API (enviado)"
                },
                "editar-cotacao": "Editar Cotação",
                "ver-detalhes": "Ver mais detalhes",
                "pedir-ajuda": "Pedir Ajuda de Especialista",
                "reabrir-cotacao": "Reabrir Cotação",
                "selecionados": {
                    "rodape": {
                        "faturamento": {
                            "a-vista": "Somente à vista ou no cartão (verificar disponibilidade)",
                            "a-vista-br": "Somente à vista ou no cartão \n (verificar disponibilidade)",
                            "faturado-ate": "Faturado em até ",
                            "faturado-somente-a-vista": "Faturamento Não Liberado - Pagamento à vista ou no cartão (verificar disponibilidade)",
                            "label": "Melhor Opção Faturamento"
                        }
                    }
                },
                "tempo-restante": "Tempo Restante",

                "modal-mais-detalhes": {
                    "comentarios": {
                        "botao-adicionar": "Adicionar",
                        "botao-ver": "Ver Comentários",
                        "titulo": "Comentários"
                    },
                    "titulo": "Detalhes da Cotação",
                    "codigo": "Código",
                    "criada-em": "Criada em",
                    "chassi": "Chassi",
                    "data-entrada-em": "Veículo agendado para",
                    "seguradora": "Seguradora",
                    "obs-comprador": "Obs. oficina",
                    "pecas": "Peças",
                    "fechar": "Fechar",
                    "fotos": {
                        "selecione": "Selecione uma imagem...",
                        "titulo": "Fotos"
                    },
                    "limite-upload": "Tamanho máximo por imagem: 5MB",
                    "remover-peca": {
                        "mensagens": {
                            "erro": {
                                "corpo": "Houve um erro ao tentar remover esta peça",
                                "titulo": "Erro!"
                            },
                            "sucesso": {
                                "corpo": "Peça removida com sucesso",
                                "titulo": "Sucesso!"
                            }
                        },
                        "titulo": "Deseja realmente remover a peça {0}?"
                    }
                },
                "modal-confirmar-compra": {
                    "alerta-bo": "antes de emitir o pedido, lembre-se de confirmar com o vendedor se as peças com pedido de fábrica não entraram em BO.",
                    "alerta-72": "Orçamento Antigo (mais de 3 dias). Avalie com o vendedor se ele ainda tem as peças.",
                    "alinhar-desconto": "Alinhar desconto com o primeiro",
                    "complemento-fiscal": {
                        "alert": "Selecione uma opção para complemento fiscal",
                        "com": "Com Complemento Fiscal",
                        "pendente": "Escolha a opção de complemento fiscal...",
                        "sem": "Sem Complemento Fiscal"
                    },
                    "confirm": {
                        "alterar-datas": "Deseja alterar a data deste(s) pedido(s) para a mais distante e entregar tudo junto?"
                    },
                    "taxa-partsfy": "Taxa Cashback Partsfy",
                    "titulo": "Confirmação de Compra",
                    "mais-um-cnpj": "Selecione o CNPJ para faturamento:",
                    "tabela": {
                        "descricao": "Descrição",
                        "arraste": "Arraste o desconto para a esquerda para receber Cashback",
                        "total": "Valor Total",
                        "pagamento": "Forma de Pagamento"
                    },
                    "botao": {
                        "fechar": "Fechar",
                        "finalizar": "Finalizar Compra",
                        "manter": "Manter Originais",
                        "trocar": "Trocar",
                        "via-api": "Enviar API"
                    },
                    "cashback": {
                        "parte-1": "Você receberá R$",
                        "parte-2": "de Cashback",
                        "tooltip": "Este vendedor disponibiliza cashback"
                    }
                },
                "titulo": "Condições Escolhidas"
            }
        },
        "curador": {
            "cabecalho": {
                "atualizar": "Atualizar Tela",
                "filtro-fase": {
                    "confirmacao": "Aguardando Confirmação",
                    "cotacao": "Em Cotação",
                    "devolucao": "Troca / Devolução",
                    "entrega": "Aguardando Entrega",
                    "todos": "Todas Fases"
                },
                "filtro-inconsistencias": "Só Inconsistências",
                "filtro-link-externo": "Só Link Externo",
                "filtro-aguardando-nota": "Só Aguardando Nota",
                "placeholder": "Filtre as cotações por código, marca, oficina, fornecedor, veículo..."
            },
            "inconsistencias": {
                "botao": {
                    "ver-pedido": "Ver Pedido"
                },
                "editar-peca": {
                    "adicionar": "Adicionar Complemento",
                    "associar": {
                        "botao": "Associar",
                        "confirm": "Deseja realmente associar esta peça com esta NF?",
                        "ninguem-selecionado": "Selecione uma nota antes de prosseguir",
                        "titulo": "Escolha a NF para associar",
                        "tooltip": "Associar com NF"
                    },
                    "editar": {
                        "label": "Part Number",
                        "obrigatorio": "É obrigatório inserir um part number",
                        "titulo": "Insira o part number como na NF",
                        "tooltip": "Editar PartNumber"
                    }
                },
                "mensagens": {
                    "erro": {
                        "associar": {
                            "corpo": "Não foi possível associar esta peça com a NF",
                            "titulo": "Erro!"
                        },
                        "buscar-dados-nf": {
                            "corpo": "Não foi possível buscar os dados das NFs associadas a este pedido",
                            "titulo": "Erro!"
                        },
                        "editar": {
                            "corpo": "Não foi possível editar o part number desta peça",
                            "corpo-partnumber-nao-encontrado": "Nenhum part number com este valor foi encontrado na NF",
                            "titulo": "Erro!"
                        },
                        "inconsistencia-nao-encontrada":{
                            "corpo": "Não foi possível encontrar nenhuma inconsistência",
                            "titulo": "Erro!"
                        },
                        "resolver": {
                            "corpo": "Não foi possível resolver estas inconsistências",
                            "titulo": "Erro!"
                        }
                    },
                    "sucesso": {
                        "associar": {
                            "corpo": "Peça associada a NF",
                            "titulo": "Sucesso!"
                        },
                        "editar": {
                            "corpo": "Part Number da peça editado",
                            "titulo": "Sucesso!"
                        },
                        "resolver": {
                            "corpo": "Inconsistências resolvidas com sucesso",
                            "titulo": "Sucesso!"
                        }
                    }
                },
                "panel": {
                    "dados-vendedor": {
                        "empresa": "Empresa",
                        "nome": "Nome",
                        "whatsapp": {
                            "label": "WhatsApp",
                            "nao-tem": "Este vendedor não tem whatsapp cadastrado"
                        }
                    },
                    "inconsistencias": {
                        "resolver": "Resolver Inconsistências",
                        "texto": "Inconsistência",
                        "juntar-pedidos": "Juntar Pedidos"
                    },
                    "pecas": {
                        "entrega": "Entrega",
                        "nome": "Peça",
                        "quantidade": "Qtd",
                        "seguradora-preco": "Cia Preço",
                        "vendedor-preco": "{{system}} Preço",
                        "vendedor-total": "Total"
                    },
                    "titulo": {
                        "dados-vendedor": "Dados Vendedor",
                        "inconsistencia": "Inconsistências",
                        "peca": "Peças"
                    },
                    "total-pedido": "Valor Pedido"
                },
                "resolver": {
                    "botao-resolver": "Resolver",
                    "obrigatorio": "É obrigatório o preenchimento do motivo",
                    "placeholder": "Descreva brevemente o motivo da conclusão destas inconsistências",
                    "subtitulo": "Preencha o motivo desta ação"
                },
                "titulo": "Lista de Inconsistências do"
            },
            "mensagens": {
                "confirm": {
                    "marcar-devolvido": "Deseja realmente marcar esta {type} como resolvida?",
                    "tipo": {
                        "devolucao": "devolução",
                        "troca": "troca"
                    }
                },
                "erro": {
                    "carregamento": {
                        "corpo": "Não foi possível carregar a lista da tela de curadoria",
                        "titulo": "Erro!"
                    },
                    "marcar-devolvido": {
                        "corpo": "Não foi possível marcar este pedido como resolvido",
                        "titulo": "Erro!"
                    }
                },
                "sucesso": {
                    "marcar-devolvido": {
                        "corpo": "Pedido devolvido marcado como resolvido",
                        "titulo": "Sucesso!"
                    }
                },
                "nenhuma-cotacao-encontrada": "Nenhuma cotação ou pedido foram encontrados"
            },
            "tabela": {
                "dados": {
                    "data-abertura": "Abertura",
                    "data-compra": "Data Compra",
                    "data-entrega": "Próx Entrega",
                    "em-analise": "Em Análise",
                    "total-pecas-entregues": "Peças Entregues",
                    "total-pecas-respondidas": "Peças Respondidas",
                    "total-respostas": "Respostas"
                },
                "detalhes": "Detalhes",
                "fase": "Fase",
                "fornecedor": "Fornecedor",
                "id": "Id Pedido",
                "oficina": "Oficina",
                "semaforo": "",
                "veiculo": "Veículo"
            },
            "juntar-pedidos": {
                "juntar-pedido": "Juntar pedido",
                "juntar-pedidos": "Juntar Pedidos",
                "id-pedido": "Id Pedido",
                "descricao": "Descrição",
                "codigo-da-peca": "Código da Peça",
                "nome-da-peca": "Nome da Peça",
                "valor-final": "Valor final",
                "pecas": "Peças",
                "confirmar-juntar-pedidos": "O pedido selecionado será removido da plataforma e as peças do pedido serão adicionadas como complemento no pedido atual. Deseja continuar?",
                "botoes": {
                    "sim": "Sim",
                    "nao": "Não"
                },
                "pedido-numero": "Pedido #",
                "modal-subtitulo": "Selecione um pedido abaixo para juntar",
                "mensagem-acoes-modal": {
                    "sucesso": {
                        "titulo": "Sucesso!",
                        "corpo": "Junção de pedidos realizada com sucesso"
                    },
                    "erro": {
                        "titulo": "Erro!",
                        "corpo": "Ocorreu um erro ao realizar a junção dos pedidos"
                    }
                }
            }
        },
        "dados-pedido": {
            "botoes": {
                "adicionar-complemento": "Adicionar Complemento",
                "alterar-dados": "Alterar Dados",
                "atualizar": "Atualizar Dados Pedido",
                "cancelar": "Cancelar",
                "cancelar-entrega": "Cancelar Entrega",
                "cancelar-pedido": "Cancelar Pedido",
                "confirmar-devolucao": "Escolher Peças",
                "confirmar-entrega": "Confirmar Entrega",
                "confirmar-pedido": "Confirmar Pedido",
                "devolver": "Trocar ou Devolver Peças",
                "fechar": "Fechar",
                "salvar": "Salvar"
            },
            "cashback": "Pedido com Cashback",
            "confirmar-entrega": {
                "botoes": {
                    "sim": "SIM",
                    "nao": "NÃO"
                },
                "corpo": "Deseja realmente confirmar essa entrega?",
                "titulo": "Confirmar Entrega"
            },
            "itens": {
                "cabecalho": {
                    "condicoes": "Comparar Condições",
                    "data": "Pedido Em:",
                    "chassi": "Chassi",
                    "seguradora": "Seguradora",
                    "forma-pagamento": "Forma de Pagamento",
                    "pagamento-a-vista": "Pagamento à vista ou no cartão",
                    "pagamento-a-vista-aviso": "Verificar disponibilidade",
                    "forma-pagamento-antigo": "Forma de Pagamento Original",
                    "frete": "Frete",
                    "mais-info": {
                        "label": "Mais Informações",
                        "botao": "Fotos e NFs"
                    }
                },
                "outros": {
                    "manha": " - Manhã",
                    "tarde": " - Tarde"
                },
                "pecas": {
                    "quantidade": "Qtd.",
                    "peca": "Peça",
                    "marca": "Marca",
                    "valor": "Vlr Unit",
                    "desconto": "Desc.",
                    "total": "Total",
                    "situacao": "Situação",
                    "situacao-data": "Data",
                    "entrega": {
                        "label": "Entrega",
                        "tooltip": "Em Dias Úteis",
                        "tooltip-mudanca-data": "Data Prevista Entrega Original"
                    }
                },
                "rodape": {
                    "total": "Total",
                    "total-pecas": "Total (Peças)",
                    "frete": "Frete"
                }
            },
            "mensagens": {
                "adicionar-complemento": {
                    "erro": {
                        "dados-invalidos": {
                            "titulo": "Ocorreu um erro",
                            "corpo": {
                                "quantity": "A quantidade de peças deve ser maior do que zero",
                                "delivery-time-id": "Prazo de entrega da peça está inválido",
                                "discount": "O desconto da peça deve ser maior ou igual a zero",
                                "description": "O nome da peça deve estar preenchido",
                                "price": "O preço da peça deve ser maior do que zero"
                            }
                        },
                        "salvar": {
                            "titulo": "Ops",
                            "corpo": "Ocorreu um erro ao tentar alterar os dados desta cotação"
                        }
                    },
                    "sucesso": {
                        "salvar": {
                            "titulo": "Sucesso!",
                            "corpo": "Dados alterados com sucesso!"
                        }
                    }
                },
                "alterar": {
                    "erro": {
                        "dados-invalidos": {
                            "titulo": "Ocorreu um erro",
                            "corpo": {
                                "delivery-time-id": "Prazo de entrega da peça <{0}> está inválido",
                                "item-answer-id": "O código da peça <{0}> está inválido",
                                "invalid-date": "A data de entrega da peça <{0}> está inválida",
                                "price": "O preço da peça <{0}> deve ser maior do que zero"
                            }
                        },
                        "salvar": {
                            "titulo": "Ops",
                            "corpo": "Ocorreu um erro ao tentar alterar os dados desta cotação"
                        }
                    },
                    "sucesso": {
                        "salvar": {
                            "titulo": "Sucesso!",
                            "corpo": "Dados alterados com sucesso!"
                        }
                    }
                },
                "cancelar-entrega": {
                    "sucesso": {
                        "titulo": "Cancelamento de Peça Efetuado",
                        "corpo": "Operação realizada com sucesso"
                    }
                },
                "cancelar-pedido": {
                    "sucesso": {
                        "titulo": "Cancelamento de Pedido Efetuada",
                        "corpo": "Operação realizada com sucesso"
                    }
                },
                "confirmar-entrega": {
                    "cashback": {
                        "titulo": "Cashback Recebido",
                        "corpo-parte-1": "Parabéns! Você acaba de receber ",
                        "corpo-parte-2": " de cashback"
                    },
                    "sucesso": {
                        "titulo": "Confirmação de Entrega Efetuada",
                        "corpo": "Operação realizada com sucesso"
                    }
                },
                "confirmar-pedido": {
                    "corpo": "O fornecimento de todas as peças deste pedido será confirmado.",
                    "titulo": "Deseja prosseguir?"
                },
                "erro": {
                    "titulo": "Pedido Não Encontrado",
                    "nao-encontrado": "O pedido #xxx não foi encontrado.",
                    "sem-codigo": "O código deste pedido está inválido."
                }
            },
            "modal": {
                "abas": {
                    "fotos": {
                        "alt": "Foto Veículo",
                        "titulo": "Fotos",
                        "vazio": "Nenhuma foto foi encontrada"
                    },
                    "nfs": {
                        "titulo": "NFs"
                    }
                },
                "adicionar-complemento": {
                    "peca": {
                        "codigo": {
                            "label": "Código"
                        },
                        "desconto": {
                            "label": "Desconto (%)"
                        },
                        "descricao": {
                            "label": "Peça"
                        },
                        "marca-peca": {
                            "label": "Marca Peça"
                        },
                        "prazo": {
                            "label": "Prazo Entrega"
                        },
                        "quantidade": {
                            "label": "Qtdade"
                        },
                        "tipo-peca": {
                            "label": "Tipo Peça",
                            "tipos": {
                                "alternativa": "Alternativa",
                                "genuina": "Genuína",
                                "original": "Original"
                            }
                        },
                        "valor-total": {
                            "label": "Valor Total"
                        },
                        "valor-unitario": {
                            "label": "Valor Unitário"
                        }
                    },
                    "titulo": "Adicionar Complemento"
                }
            },
            "reabrir-pedido": {
                "titulo": "Reabrir Cotação",
                "corpo": ", você quer reabrir este pedido para comprar novamente?",
                "botoes": {
                    "sim": "SIM",
                    "nao": "NÃO",
                    "voltar": "Voltar"
                }
            },
            "cancelar-entrega-mercado": {
                "titulo": "Recomprar",
                "corpo": ", você quer refazer este pedido?",
                "botoes": {
                    "sim": "SIM",
                    "nao": "NÃO",
                    "voltar": "Voltar"
                }
            },
            "tip-vendedor": {
                "vendedor": "Vendedor",
                "email": "E-mail",
                "fone_radio": "Fone / Whats App",
                "is-billable": "Fornecedor Homologado",
                "has-cashback": "Oportunidade de Cashback"
            },
            "trocar-devolver": {
                "mensagens": {
                    "erro": {
                        "corpo": "Houve um erro nesta operação",
                        "titulo": "Erro!"
                    },
                    "sucesso": {
                        "corpo": "Operação realizada com sucesso",
                        "titulo": "Sucesso!"
                    }
                },
                "modal": {
                    "footer-2": "Continue apenas se você já tiver combinado estas condições com seu fornecedor",
                    "obrigatorio-1": "Você precisa escolher uma opção",
                    "obrigatorio-2": "Você precisa definir um motivo",
                    "opcao-2": {
                        "botao": {
                            "devolver-so": "Somente devolver",
                            "devolver-reabrir": "Devolver e reabrir",
                            "trocar": "Trocar"
                        },
                        "devolucao": "devolução",
                        "troca": "troca"
                    },
                    "titulo-1": "Escolha o que deseja fazer",
                    "titulo-2": "Defina o motivo da"
                },
                "opcoes": {
                    "devolver": "Devolver",
                    "trocar": "Trocar",
                    "voltar": "Voltar Aguardando Entrega"
                }
            }
        },
        "mercado-partsfy": {
            "navegacao": {
                "oleos-lubrificantes": "Óleos & Lubrificantes",
                "tintas-insumos": "Tintas e Insumos para Pintura"
            },
            "informacoes": {
                "quantidade-pecas": "Mostrando <b>{{quantity}}</b> de <b>{{totalQuantity}}</b> itens"
            },
            "detalhes-peca": {
                "tags": {
                    "novo": "Novo"
                },
                "informacoes": {
                    "part-number": "Part Number: ",
                    "vendedor": "Vendedor: ",
                    "cashback": "Receba {{value}} de cashback",
                    "parcelamento": "{{installmentsNumber}}x de {{installmentsPrice}} Sem Juros"
                },
                "frete": {
                    "titulo": "Frete Grátis",
                    "data-entrega": {
                        "part-1": "Chegará em ",
                        "part-2": " no endereço "
                    }
                },
                "carrinho": "Adicionar ao carrinho"
            },
            "carrinho": {
                "confirmacao": {
                    "titulo": "Será gerado um novo pedido",
                    "mensagem": "Deseja continuar?",
                    "sim": "Sim",
                    "nao": "Não"
                },
                "titulo": {
                    "vazio": "Carrinho:",
                    "um-holding": "Produtos de:",
                    "varios-holdings": {
                        "principal": "Carrinho múltiplo",
                        "quantidade-holdings": "Seu carrinho possui <b>{{quantity}} vendedores</b> diferentes"
                    }
                },
                "quantidade-itens": {
                    "um-item": " item",
                    "varios-item": " itens",
                    "vazio": "Vazio"
                },
                "vazio": {
                    "titulo": "Seu carrinho está vazio",
                    "botao": "Adicionar Produtos"
                },
                "varios-vendedores": {
                    "produtos": "Produtos: ",
                    "previsao-entrega": {
                        "pagante": "Chegará em {{date}} por <b>{{price}}</b>",
                        "gratis": "Chegará <b>Grátis</b> em {{date}}"
                    }
                },
                "footer": {
                    "previsao-entrega": "O seu pedido possui previsão de ser entregue em <b>{{date}}</b> no endereço <b>{{address}}</b>",
                    "informacoes-preco": {
                        "produtos": "Produtos ",
                        "frete": "Frete:",
                        "frete-gratis": "Grátis!",
                        "total": "Total:"
                    },
                    "botoes": {
                        "comprar-mais": "Comprar Mais",
                        "pagamento": "Finalizar Compra"
                    }
                }
            },
            "filtro-lateral": {
                "filtros": {
                    "brand": "Montadora",
                    "tags": {
                        "all-brands": "Todas Montadoras"
                    }
                },
                "titulo": "Filtros Auxiliares"
            },
            "peca-card": {
                "cashback": {
                    "part-1": "Receba ",
                    "part-2": " de cashback"
                },
                "frete-gratis": "Frete Grátis",
                "parcelamento": {
                    "part-1": "x de ",
                    "part-2": " Sem Juros"
                }
            },
            "listagem-vazia": {
                "titulo": "Nenhum produto encontrado",
                "descricao": "Não encontrou o que buscava?! Faça uma cotação e receba o seu pedido em poucos dias!",
                "botao": "Fazer Cotação"
            }
        },
        "meus-vendedores": {
            "cabecalho": {
                "empresa": "Empresa",
                "vendedor": "Vendedor Escolhido"
            },
            "mensagens": {
                "confirm": {
                    "bloquear-fornecedor": "Deseja realmente evitar que este fornecedor participe de suas cotações?"
                },
                "sucesso": {
                    "alterar-vendedor": {
                        "corpo": "Operação Realizada Com Sucesso",
                        "titulo": "O vendedor foi alterado"
                    },
                    "bloquear-fornecedor": {
                        "corpo": "Operação Realizada Com Sucesso",
                        "titulo": "Este fornecedor não participará mais de suas cotações"
                    },
                    "desbloquear-fornecedor": {
                        "corpo": "Operação Realizada Com Sucesso",
                        "titulo": "Este fornecedor irá participar de suas cotações novamente"
                    }
                },
                "erro": {
                    "alterar-vendedor": {
                        "corpo": "Ocorreu um erro desconhecido",
                        "titulo": "Erro ao alterar este vendedor"
                    },
                    "bloquear-fornecedor": {
                        "corpo": "Ocorreu um erro desconhecido",
                        "titulo": "Erro ao bloquear o fornecedor"
                    },
                    "carregamento": {
                        "corpo": "Ocorreu um erro desconhecido",
                        "titulo": "Erro ao listar seus vendedores vinculados"
                    },
                    "desbloquear-fornecedor": {
                        "corpo": "Ocorreu um erro desconhecido",
                        "titulo": "Erro ao desbloquear o fornecedor"
                    }
                }
            },
            "placeholder": "Procure Pela Empresa Aqui",
            "titulo": "Selecione Seus Vendedores",
            "tooltip": {
                "bloquear-fornecedor": "Impedir que o fornecedor visualize suas cotações",
                "desbloquear-fornecedor": "Permitir que o fornecedor visualize suas cotações novamente"
            }
        },
        "visao-geral": {
            "colunas": {
                "aguardando-compra": {
                    "botoes": {
                        "cashback": "Oportunidade de Cashback",
                        "cashback-pedido": "Pedido com Cashback",
                        "criar-1": "CRIAR",
                        "criar-2": "NOVA COTAÇÃO",
                        "comprar": "Comprar",
                        "detalhes": "Detalhes",
                        "distribuindo": "Distribuindo...",
                        "excluir": "Excluir Cotação",
                        "pedir-ajuda": "Pedir Ajuda Especialista",
                        "tem-resposta": "Já existem respostas nesta cotação",
                        "de_volta": " de volta",
                        "via-api": "Enviar API",
                        "via-api-enviado": "Enviar API (enviado)"
                    }
                },
                "aguardando-entrega": {
                    "status": {
                        "atrasado": "ATRASADO",
                        "entrega": "ENTREGA",
                        "hoje": "HOJE",
                        "amanha": "AMANHÃ",
                        "confirmacao": "AGUARDANDO CONFIRMAÇÃO"
                    },
                    "botoes": {
                        "detalhes": "Detalhes"
                    },
                    "entrega": {
                        "peca-singular": "peça entregue",
                        "de": "de",
                        "peca-plural": "peças entregues",
                        "comprada-singular": "comprada",
                        "comprada-plural": "compradas",
                        "aguardando_pecas": "Aguardando entrega de ",
                        "peca-singular2": " peça",
                        "peca-plural2": " peças"
                    }
                },
                "cotacao-singular": "COTAÇÃO",
                "cotacao-plural": "COTAÇÕES",
                "pedido-singular": "PEDIDO",
                "pedido-plural": "PEDIDOS",
                "nenhuma-cotacao-encontrada": "NENHUMA COTAÇÃO ENCONTRADA",
                "nenhum-pedido-encontrado": "NENHUM PEDIDO ENCONTRADO",
                "titulos": {
                    "aguardando-compra": "Aguardando Compra",
                    "aguardando-entrega": "Aguardando Entrega",
                    "atrasado": "Atrasado",
                    "confirmacao": "Aguardando Confirmação",
                    "despachado": "Despachado",
                    "entrega-amanha": "Entrega Amanhã",
                    "entrega-hoje": "Entrega Hoje",
                    "ultimos-pedidos": "Pedidos dos Últimos 7 dias"
                },
                "ultimos-pedidos": {
                    "botoes": {
                        "detalhes": "Detalhes"
                    },
                    "ver-historico": "Ver Histórico"
                }
            },
            "mensagens": {
                "avaliacoes": {
                    "botao-cancelar": "Deixar para depois",
                    "botao-confirmar": "Avaliar agora",
                    "titulo": "Avalie sua experiência e ajude a comunidade de oficinas identificar os melhores fornecedores!"
                },
                "cta-v8": {
                    "botao-migrar": "Quero Migrar Agora",
                    "botao-reabrir": "Somente reenviar cotação para meus fornecedores",
                    "corpo": "Tenha um time disponível para correr atrás de peças e achar as melhores condições",
                    "titulo": "Migre Para o Plano V8"
                },
                "pedir-ajuda": {
                    "botao": "Pedir Ajuda",
                    "botao-reabrir": "Somente Reabrir",
                    "confirm": "Precisando de uma ajuda extra nesta cotação?",
                    "motivo": {
                        "obrigatorio": "O motivo do pedido é obrigatório",
                        "placeholder": "Descreva a sua necessidade de ajuda aqui"
                    },
                    "mensagem": {
                        "erro": {
                            "titulo": "Ocorreu um erro",
                            "corpo": "Não foi possível solicitar ajuda ao especialista"
                        },
                        "sucesso": {
                            "titulo": "Sucesso!",
                            "corpo": "Seu pedido de ajuda foi enviado ao especialista"
                        }
                    }
                },
                "erro": {
                    "carregamento": {
                        "corpo": "Não foi possível carregar a sua lista de pedidos",
                        "titulo": "Erro Desconhecido"
                    },
                    "excluir-cotacao": {
                        "comment-obrigatorio": {
                            "corpo": "Por favor, informe o motivo",
                            "titulo": "Motivo Obrigatório"
                        },
                        "gravacao": {
                            "corpo": "Não foi possível excluir essa cotação",
                            "titulo": "Erro Desconhecido"
                        }
                    },
                    "reabrir": {
                        "corpo": "Não foi possível reabrir essa cotação",
                        "titulo": "Erro Desconhecido"
                    }
                },
                "sucesso": {
                    "reabrir": {
                        "corpo": "A cotação está reaberta",
                        "titulo": "Operação Realizada Com Sucesso"
                    }
                }
            },
            "filtro": "Busque pelo veículo ou placa"
        },
        "nova-cotacao": {
            "titulo": "Nova Cotação",
            "mensagens": {
                "imagem-erro": {
                    "corpo": "Ocorreu um erro desconhecido",
                    "titulo": "Erro no Upload da Imagem"
                },
                "imagem-existente": {
                    "corpo": "Não é possível incluir mais de uma imagem com o mesmo nome<br>Imagem: {0}",
                    "titulo": "Imagem Já Cadastrada"
                },
                "imagem-limite-tamanho": {
                    "corpo": "Limite de tamanho da imagem excedido!<br>Imagem: {0}",
                    "titulo": "Limite de tamanho"
                },
                "imagem-tipo": {
                    "corpo": "Tipo de imagem não permitido!<br>Imagem: {0}",
                    "titulo": "Tipo da imagem"
                },
                "imagem-limite-selecao": {
                    "corpo": "Limite de imagens excedido, selecione no maximo {0} imagens!",
                    "titulo": "Limite de imagens"
                },

                "sucesso": {
                    "titulo": "Salvo com sucesso",
                    "corpo": "Cotação salva sucesso"
                },
                "erro-upload_foto": {
                    "titulo": "Atenção"
                },
                "erro": "Houve um erro ao tentar realizar o cadastro.<br />Aguarde e tente novamente mais tarde",
                "atencao": "Atenção"
            },
            "botao": {
                "audatex_soma": {
                    "label": "Importar Orçamento",
                    "label-menor": "Audatex, Cília, Orion ou Soma",
                    "sucesso": {
                        "titulo": "Upload com sucesso",
                        "corpo": "Dados importados com sucesso"
                    }
                },
                "salvar": "Solicitar Nova Cotação",
                "cancelar": "Cancelar"
            },
            "tipo-cotacao": {
                "label": "Objetivo",
                "obrigatorio": "O objetivo da cotação é obrigatório",
                "opcoes": {
                    "compra": "Cota/Compra",
                    "orcamento": "Apenas Orçamento",
                    "orcamento-menor1024": "Pegar Preço e Prazo"
                }
            },
            "tipo_peca": {
                "label": "Tipo de Peça",
                "obrigatorio": "O tipo de peça é obrigatório"
            },
            "ano": {
                "label": "Ano",
                "obrigatorio": "O ano do veículo é obrigatório",
                "min-max": "O ano do veículo deve estar entre 1950 e {0}"
            },
            "chassi": {
                "label": "Chassi",
                "obrigatorio": "O chassi do veículo é obrigatório",
                "formato-invalido": "Formato chassi inválido. Deve conter 17 caracteres"
            },
            "marca": {
                "label": "Marca",
                "placeholder": "Selecione a marca",
                "obrigatorio": "A marca do veículo é obrigatória"
            },
            "placa": {
                "label": "Placa",
                "obrigatorio": "A placa do veículo é obrigatório",
                "formato-invalido": "Formato placa inválido"
            },
            "seguradora": {
                "label": "Seguradora",
                "placeholder": "Selecione seguradora",
                "obrigatorio": "A seguradora é obrigatória"
            },
            "veiculo": {
                "label": "Veículo",
                "placeholder": "Digite o veículo e seu modelo",
                "obrigatorio": "O nome do veículo é obrigatório"
            },
            "observacao": {
                "label": "Observações",
                "placeholder": "Insira aqui informações extra como: Direção hidráulica, ar condicionado, etc. Ou algum recado para o vendedor..."
            },
            "links": {
                "fotos": "Inserir Fotos"
            },
            "pecas": {
                "obrigatorio": "Ao menos uma peça deve ser cadastrada",
                "dados": {
                    "descricao": {
                        "label": "Descrição",
                        "placeholder": "Descrição da peça",
                        "obrigatorio": "O nome da peça é obrigatório"
                    },
                    "quantidade": {
                        "label": "Quantidade",
                        "obrigatorio": "O campo Quantidade é obrigatório e deve ser maior do que zero"
                    }
                },
                "tabela": {
                    "peca": "Peça",
                    "codigo": "Código",
                    "quantidade": "Quantidade",
                    "vazia": "Nenhuma peça foi adicionada"
                }
            },
            "api-plate": {
                "plate-found": "Placa encontrada",
                "plate-not-found": "Placa não encontrada",
                "title": "Atenção"
            }
        },
        "pecas-canceladas": {
            "botoes": {
                "reabrir": "Reabrir cotação",
                "recomprar": "Recomprar",
                "ignorar": "Ignorar notificação",
                "fechar": "Fechar"
            },
            "cabecalho": {
                "titulo": "Peças",
                "peca-nome": "Peça Cancelada"
            },
            "motivo": "Motivo: ",
            "mensagens": {
                "atualizar": {
                    "confirm": {
                        "cancelar": "Deseja realmente abrir uma nova cotação com as peças selecionadas?",
                        "ignorar": "Deseja realmente ignorar essa notificação?",
                        "recomprar": "Deseja realmente ignorar essa notificação e ir para o Mercado Partsfy?"
                    }
                },
                "erro-atualizar": {
                    "corpo": "Houve um erro desconhecido ao tentar reabrir a cotação",
                    "titulo": "Operação Não Realizada"
                },
                "sem-pecas-selecionadas": "Selecione ao menos 1 peça"
            }
        },
        "pedidos": {
            "filtro": {
                "pesquisa": {
                    "placeholder": "Busca Veículo/Placa/Marca",
                    "titulo-1": "Pesquisa",
                    "titulo-2": "(Últimos 30 dias):"
                },
                "situacao": {
                    "opcoes": {
                        "aguardando-entrega": "Aguardando Entrega",
                        "em-analise": "Em Análise",
                        "entregue": "Peças Entregues",
                        "rejeitado": "Peças Rejeitadas",
                        "todos": "Todos"
                    },
                    "titulo": "Situação Pedido:"
                }
            },
            "historico": {
                "botao": "Pesquisar!",
                "placeholder": "Digite aqui a sua busca por marca, veículo ou placa (Formato: XXX-1234)",
                "titulo": "Busque pelo pedido no seu histórico",
                "vazio": {
                    "inicial": "Digite os dados do veículo e clique em pesquisar para encontrar seu pedido",
                    "pos-pesquisa": "Nenhum pedido foi encontrado com este filtro"
                }
            },
            "mensagens": {
                "sem-pedido": "Nenhum pedido foi encontrado",
                "erro": {
                    "carregamento": {
                        "corpo": "Ocorreu um erro desconhecido",
                        "titulo": "Erro ao Realizar Pesquisa"
                    },
                    "nao-encontrado": "O pedido #xxx não foi encontrado."
                }
            }
        },
        "semaforo": {
            "cabecalho": {
                "atualizar": "Atualizar Tela",
                "filtro-fase": {
                    "confirmacao": "Aguardando Confirmação",
                    "cotacao": "Em Cotação",
                    "entrega": "Aguardando Entrega",
                    "todos": "Todas Fases"
                },
                "placeholder": "Filtre as cotações por código, marca, oficina, veículo..."
            },
            "mensagens": {
                "erro": {
                    "carregamento": {
                        "corpo": "Não foi possível carregar a lista do semáforo",
                        "titulo": "Erro!"
                    }
                },
                "nenhuma-cotacao-encontrada": "Nenhuma cotação ou pedido foram encontrados"
            },
            "tabela": {
                "comentarios": {
                    "titulo": "Comentários"
                },
                "dados": {
                    "data-abertura": "Abertura",
                    "data-compra": "Data Compra",
                    "data-entrega": "Próx Entrega",
                    "em-analise": "Em Análise",
                    "total-pecas-entregues": "Peças Entregues",
                    "total-pecas-respondidas": "Peças Respondidas",
                    "total-respostas": "Respostas"
                },
                "detalhes": "Detalhes",
                "fase": "Fase",
                "id": "Id Pedido",
                "oficina": "Oficina",
                "semaforo": "",
                "veiculo": "Veículo",
                "id-cotacao": "Id Cotação"
            }
        }
    },
    "componente": {
        "nota-fiscal": {
            "mensagens": {
                "erro": {
                    "excluir": {
                        "corpo": "Não foi possível remover esta NF",
                        "titulo": "Erro!"
                    },
                    "salvar-transportadora": {
                        "corpo": "Não foi possível salvar os dados da transportadora",
                        "titulo": "Erro!"
                    }
                },
                "sucesso": {
                    "excluir": {
                        "corpo": "NF removida com sucesso",
                        "titulo": "Sucesso!"
                    },
                    "salvar-transportadora": {
                        "corpo": "Dados da transportadora salvos com sucesso",
                        "titulo": "Sucesso!"
                    }
                }
            },
            "modal": {
                "botoes": {
                    "deixar-depois": "Deixar para depois"
                },
                "codigo-rastreio": {
                    "label": "Código Rastreio",
                    "obrigatorio": "O código de rastreio é obrigatório"
                },
                "titulo": "Selecione a transportadora e seu código de rastreio",
                "transportadora": {
                    "label": "Transportadora",
                    "placeholder": "Digite o nome da transportadora",
                    "obrigatoria": "É preciso selecionar uma transportadora",
                    "outra-obrigatoria": "O nome da transportadora é obrigatório"
                }
            },
            "tabela": {
                "nota": {
                    "baixar": "Baixar",
                    "coluna": "Nota Fiscal",
                    "excluir": {
                        "confirm": "Deseja realmente remover esta nota fiscal?",
                        "titulo": "Excluir"
                    },
                    "transportadora": "Transportadora",
                    "ver": "Ver"
                }
            },
            "titulo": "Notas Fiscais do Pedido #",
            "vazio": "Nenhuma nota fiscal foi adicionada a este pedido"
        }
    },
    "elemento": {
        "init": "Iniciado",
        "generico-botao": {
            "adicionar": "Adicionar",
            "anterior": "Anterior",
            "baixar": "Baixar",
            "cancelar": "Cancelar",
            "confirmar": "Confirmar",
            "enviar": "Enviar",
            "fechar": "Fechar",
            "finalizar": "Finalizar",
            "liberar": "Liberar",
            "proximo": "Próximo",
            "remover": "Remover",
            "salvar": "Salvar",
            "tela-login": "Tela de Login",
            "voltar": "Voltar"
        },
        "generico-input": {
            "placeholder": "Digite Aqui"
        },
        "generico-select": {
            "nao": "Não",
            "selecione": "Selecione",
            "sim": "Sim",
            "todas": "Todas",
            "todos": "Todos"
        },
        "tipo-pecas": {
            "titulo": "Tipo de Peças",
            "genuina": "Genuína (Concessionária)",
            "genuina-2": "Genuína",
            "original": "Original (Fornecedor)",
            "original-2": "Original",
            "alternativa": "Alternativa",
            "alternativa-2": "Alternativa",
            "obrigatorio": "O tipo de peças é obrigatório"
        },
        "alerta-conexao": {
            "titulo": "Oopss! Parece que a conexão está oscilando",
            "corpo": "Aguarde um momento e tente abrir a tela novamente. Caso o problema continue, entre em contato com nosso suporte."
        },
        "uploader": {
            "erro": "Houve um erro no upload. Olhe o console do browser para mais informações",
            "formato-invalido": "O arquivo deve ser no formato: ",
            "lista-erro": "Erros no Processo Upload",
            "oficina-obrigatoria": "É obrigatório selecionar uma oficina",
            "sucesso": "Upload realizado com sucesso"
        },
        "topbar": {
            "atendimento": {
                "label": "Atendimento\nonline",
                "title": "Preciso de Ajuda"
            },
            "search": { "PLACEHOLDER": "Pesquisar..." }
        }
    },
    "geral": {
        "dias-semana": {
            "amanha": "amanhã",
            "hoje": "hoje",
            "segunda": "segunda-feira",
            "terca": "terça-feira",
            "quarta": "quarta-feira",
            "quinta": "quinta-feira",
            "sexta": "sexta-feira",
            "sabado": "sábado",
            "domingo": "domingo"
        },
        "erro-desconhecido": "Ocorreu um erro desconhecido.",
        "fase-cotacao": {
            "abreviacao": {
                "0": "COT",
                "1": "ACO",
                "2": "ANA",
                "3": {
                    "entrega": "ENT",
                    "troca": "TRO"
                },
                "10": "DEV"
            }
        },
        "feedback": {
            "link-rapido": {
                "nao-encontrado": {
                    "subtitulo": "Aparentemente ela já virou um pedido!",
                    "titulo": "Ah, que pena. Não consegui encontrar esta cotação =("
                },
                "nao-participando": {
                    "subtitulo": "Continuarei procurando novas oportunidades para você.",
                    "titulo": "Ah, que pena que não irá participar =("
                },
                "ops": {
                    "subtitulo": "Não consegui processar esta informação. Entre em contato com o suporte.",
                    "titulo": "Ops =("
                },
                "participando": {
                    "subtitulo": "Vou finalizar sua venda e em breve entro em contato!",
                    "titulo": "Obrigado pela confirmação =)"
                }
            }
        },
        "info-geral": {
            "fornecedor": "Fornecedor",
            "mensagens": {
                "info-copiada": "Informação Copiada"
            },
            "oficina": "Oficina",
            "planos": {
                "central": "Central",
                "popular": "Popular",
                "turbo": "Turbo",
                "V8": "V8"
            }
        },
        "menu": {
            "alterar-senha": "Alterar Senha",
            "bem-vindo": "Olá,",
            "comprador": {
                "avaliacoes": "Avaliações",
                "cashback": "Cashback",
                "conversor": "Conversor",
                "convidar-vendedor": "Convidar Vendedor",
                "curador": "Curador",
                "historico": "Histórico",
                "meus-vendedores": "Meus Vendedores",
                "mercado": "Mercado",
                "pedidos": "Pedidos",
                "vendedores-convidados": "Vendedores Convidados",
                "visao-geral": "Visão Geral"
            },
            "gestor-comprador": {
                "cashback": "Cashback",
                "historico": "Histórico",
                "holding-config": "Configurações",
                "visao-geral": "Visão Geral"
            },
            "gestor-loja": {
                "cockpit": "Cockpit"
            },
            "gestor-peca": {
                "atualizar-estoque": "Atualizar Estoque",
                "configurar-cashback": "Cashback Customizado",
                "configurar-fornecimento": "Configurar Fornecimento",
                "configurar-rebate": "Cashback Padronizado",
                "cockpit": "Cockpit",
                "documentacao": "Documentação",
                "gerenciar-vendedores": "Gerenciar Vendedores",
                "relatorio-financeiro": "Relatório Financeiro"
            },
            "path": {
                "comprador": {
                    "visao-geral": {
                        "comprar": "Comprar",
                        "condicoes": "Condições",
                        "home": "Visão Geral",
                        "nova-cotacao": "Nova Cotação",
                        "pedido": "Pedido"
                    }
                },
                "vendedor": {
                    "visao-geral": {
                        "confirmar": "Confirmar Pedido",
                        "confirmar-entrega": "Confirmar Entrega",
                        "detalhe": "Detalhes Pedido",
                        "home": "Visão Geral",
                        "responder": "Responder"
                    }
                }
            },
            "supervisor-comprador": {
                "historico": "Histórico",
                "visao-geral": "Visão Geral"
            },
            "suporte": {
                "avaliacao-vendedores": "Avaliação Vendedores",
                "cadastros": "Cadastros",
                "cashback": "Cashback",
                "checar-relacao": "Checar Relação",
                "configuracoes": "Configurações",
                "contestacao": "Contestações",
                "convites": "Convites",
                "cotacoes": "Cotações",
                "diario": "Diário",
                "faturamento": "Faturamento",
                "gerenciar-vendedores": "Gerenciar Vendedores",
                "manutencao": {
                    "limpar-tela-vendedor": "Limpar Tela Vendedor",
                    "oficina-sem-documentacao": "Oficinas Sem Documentação",
                    "titulo": "Manutenção",
                    "usuario": {
                        "interno": "Usuários Internos"
                    },
                    "voltar-cotacao": "Voltar Cotação"
                },
                "pedidos": "Pedidos",
                "semaforo": "Semáforo"
            },
            "vendedor": {
                "cockpit": "Cockpit",
                "documentacao": "Documentação",
                "pedidos": "Pedidos",
                "visao-geral": "Visão Geral"
            },
            "sair": "Sair"
        },
        "not-found": {
            "home": "Ou você pode ir direto para a página principal: ",
            "login": "Ou você pode ir direto para a página de",
            "sugestao": "Você estava querendo ir para a página",
            "subtitulo": "Tem certeza que digitou o caminho corretamente?",
            "titulo": "Página não encontrada"
        },
        "manutencao": {
            "acesso-mobile": {
                "indevido": "Essa página deve ser acessada por um computador",
                "login": "Para fazer login, entre pelo link de uma cotação"
            },
            "subtitulo": "Volte novamente mais tarde",
            "titulo": "Sistema em manutenção"
        },
        "notificacao": {
            "peca-cancelada": {
                "titulo": "Pedido Alterado Pelo Vendedor",
                "modal": {
                    "message": {
                        "padrao": "Selecione as peças que deseja re-cotar abaixo:",
                        "mercado": "Deseja recomprar estas peças?"
                    },
                    "message-vazio": "As peças rejeitadas já foram tratadas. Selecione ignorar esta notificação",
                    "titulo": "Peças Canceladas Pelo Vendedor No Pedido #",
                    "veiculo": "Veículo: ",
                    "pedido": "Pedido: "
                }
            }
        },
        "slack": {
            "cta-v8": "Nova Lead Migração Popular - V8\r\n\r\nOficina: *{0}*\r\nComprador: *{1}*\r\nFone: *{2}*\r\nE-mail: *{3}*",
            "mensagens": {
                "erro": {
                    "envio": {
                        "corpo": "Houve um erro ao tentar enviar esta mensagem",
                        "titulo": "Mensagem Não Enviada"
                    }
                }
            }
        },
        "termos-uso": {
            "botao": "Já Li!",
            "mensagens": {
                "erro": {
                    "corpo": "Houve um erro no aceite dos Termos de Uso",
                    "titulo": "Erro!"
                },
                "sucesso": {
                    "corpo": "Aceite nos Termos de Uso com sucesso",
                    "titulo": "Sucesso!"
                }
            },
            "texto": {
                "p1": "Atualizamos nossos",
                "p2": "Termos de Uso",
                "p3": "Acesse",
                "p4": "aqui",
                "p5": "para saber mais"
            }
        },
        "whatsapp": {
            "aguardando-confirmacao": "😀 Você *GANHOU* uma cotação na Partsfy!\n\n*Confirme sua venda para a {0} na próxima hora para o pedido não ser cancelado!!*\nDados do veículo 🚗: {1}\n\nNão esqueça de subir na plataforma o XML da nota COM A PLACA do veículo quando for despachar o pedido.\nOFICINAS VÃO COMEÇAR A REJEITAR NF SEM PLACA\n\nAcesse e confirme: {2}",
            "aguardando-confirmacao-devolucao-troca": "🛑 Você Tem uma Nova solicitação de Troca / Devolução\n\nConfirme a solicitação para a {{1}} na próxima hora para não atrasar o processo!\n\nDados do veículo🚗: {{2}}\n\nAcesse e confirme: {{3}}",
            "data-entrega-proxima": "Oi, {0}, vi na plataforma que seu pedido para {1} ainda está sem NF incluída.\n\nESSE PEDIDO JÁ FOI DESPACHADO PARA CHEGAR NO PRAZO?\n\nCarro: {2}\nOficina: {3}\n\nCaso já tenha sido enviado, por favor insira o XML da nota na plataforma.\nSe houver alguma alteração no prazo, por favor nos avise!\n\nAcessar pedido: {4}",
            "link-rapido": {
                "externo": "Olá *{0}*, conforme conversamos, preciso que você preencha os valores que combinamos na {system} através do link abaixo:\r\n\r\n{1}\r\n\r\nFico no aguardo.\r\nObrigado",
                "interno": "Olá *{0}*, conforme conversamos, por favor responder a cotação através do link abaixo:\r\n\r\n{1}\r\n\r\nFico no aguardo.\r\nObrigado"
            },
            "mensagens": {
                "confirm": "Deseja realmente enviar esta mensagem via WhatsApp?",
                "erro": {
                    "envio": {
                        "corpo": "Houve um erro ao tentar enviar esta mensagem",
                        "titulo": "Mensagem Não Enviada"
                    }
                },
                "sucesso": {
                    "envio": {
                        "corpo": "Mensagem enviada com sucesso",
                        "titulo": "Sucesso!"
                    }
                }
            },
            "nova-cotacao": "Nova oportunidade da oficina {0} na Partsfy!\r\n\r\n🚙  {1}\n\nAproveite: {2}\n\nFicamos à disposição caso precise de ajuda.",
            "pedido-atrasado": "Oi, {0}, você tem um pedido previsto para *{1}* constando como *ATRASADO.*\n\nCarro: *{2}*\nOficina: *{3}*\n\nO atraso de entrega pode te *prejudicar a receber novas cotações.*\n\n*ESSE PEDIDO JÁ FOI DESPACHADO/ENTREGUE?*\n\nAcesse o pedido no link: {4}",
            "sem-nota": {
                "antes": "Oi {0}, este pedido que está previsto para {5} (*{1}*) já foi despachado?\r\n\r\n*{3}*\r\nOficina: *{2}*\r\n\r\nImportante: só suba o XML da nota no portal se o pedido já estiver para ser despachado.\r\n*Caso haja alguma alteração no prazo, por favor nos avise!*\r\n{4}",
                "dia": "Oi {0}, vi na plataforma que seu pedido para HOJE (*{1}*) ainda está sem NF incluída.\r\n*ESSE PEDIDO JÁ FOI DESPACHADO PARA CHEGAR NO PRAZO?*\r\n\r\n*{3}*\r\nOficina: *{2}*\r\n\r\nCaso já tenha sido enviado, por favor insira o XML da nota na plataforma.\r\n*Se houver alguma alteração no prazo, por favor nos avise!*\r\n{4}",
                "atraso": "Oi {0}, o pedido previsto para *{1}* consta como *ATRASADO*.\r\n\r\n*{3}*\r\nOficina: *{2}*\r\n\r\nO atraso de entrega pode te *prejudicar* a receber novas cotações.\r\n\r\n*ESSE PEDIDO JÁ FOI DESPACHADO? VOCÊ SABE SE JÁ FOI ENTREGUE?*\r\n\r\n{4}"
            }
        },
        "pedido": {
            "codigo": "Código: #"
        }
    },
    "login": {
        "titulo": "INSIRA SEUS DADOS PARA ACESSAR O SISTEMA",
        "multi-usuario": {
            "mensagens": {
                "erro": {
                    "corpo": "Não foi possível trocar de usuário",
                    "titulo": "Ops!"
                },
                "sucesso": {
                    "corpo": "Usuário trocado com sucesso",
                    "titulo": "Sucesso!"
                }
            },
            "titulo": {
                "empresa": "Você está vendo a empresa:",
                "usuario": "Você está vendo o usuário:"
            }
        },
        "mensagens": {
            "usuario-senha-invalido": "Login e/ou senha inválidos",
            "usuario-pagante-expirado": "Seu plano de usuário pagante não foi renovado, entre em contato com seu gerente para liberar novamente seu usuário e avise o suporte da {system}"
        },
        "botao": { "entrar": "ENTRAR" },
        "termos-uso": {
            "corpo": "Clique aqui para lê-lo",
            "eu-li": "Já li e quero continuar",
            "footer": "Termos de Uso",
            "titulo": "Atualizamos nossos Termos de Uso"
        },
        "textbox": {
            "login": {
                "placeholder": "Insira seu login *",
                "obrigatorio": "O campo de login é obrigatório"
            },
            "senha": {
                "placeholder": "Insira sua senha *",
                "obrigatorio": "O campo de senha é obrigatório"
            }
        },
        "change-password": {
            "titulo": "Alteração de senha",
            "voltando": "Voltando a tela anterior",
            "botao": {
                "alterar": "ALTERAR",
                "voltar": "Voltar"
            },
            "mensagens": {
                "sucesso": "Senha alterada com sucesso.",
                "senha_atual_incorreta": "Senha atual incorreta"
            },
            "senha_atual": {
                "placeholder": "Insira sua senha atual",
                "obrigatorio": "O campo senha atual é obrigatório"
            },
            "nova_senha": {
                "placeholder": "Insira sua nova senha",
                "obrigatorio": "O campo nova senha é obrigatório",
                "comprimento_invalido": "A nova senha deve ter no mínimo 4 caracteres"
            },
            "nova_senha_confirmacao": {
                "placeholder": "Confirme sua nova senha",
                "obrigatorio": "O campo confirmação de senha é obrigatório",
                "comprimento_invalido": "A confirmação de senha deve ter no mínimo 4 caracteres",
                "senha_e_confirmacao_diferentes": "A senha e a confirmação da senha devem ser iguais."
            }
        },
        "forgot-password": {
            "titulo": "Esqueci minha senha",
            "email": {
                "label": "E-mail",
                "placeholder": "Digite aqui seu E-mail",
                "formato-invalido": "O formato do campo e-mail está inválido",
                "obrigatorio": "O campo e-mail é obrigatório"
            },
            "botao": {
                "abrir": "Esqueci minha senha",
                "enviar": "Enviar",
                "voltar": "Voltar"
            },
            "mensagens": {
                "sucesso": "Senha enviada com sucesso para o e-mail cadastrado",
                "not_found": "E-mail não encontrado em nossa base de dados",
                "captcha-error": "Selecione a opção que você não é um robô"
            }
        },
        "logout": {
            "erro": {
                "corpo": "Não foi possível efetuar o logout",
                "titulo": "Erro Desconhecido"
            }
        }
    },
    "part-manager": {
        "atualizar-estoque": {
            "mensagens": {
                "alerta": "Este processo pode demorar alguns minutos. Deseja continuar?",
                "erro": {
                    "carregamento": {
                        "corpo": "Não foi possível carregar os dados iniciais da holding",
                        "titulo": "Operação Não Realizada"
                    },
                    "salvar": {
                        "corpo": "Não foi possível atualizar o estoque",
                        "titulo": "Operação Não Realizada"
                    }
                }
            },
            "passos": {
                "passo-1": {
                    "erro": {
                        "corpo": "Você deve escolher o tipo do arquivo",
                        "titulo": "Ops!"
                    },
                    "erro-upload": {
                        "baixar-log": "Baixar Log Erro",
                        "reiniciar": "Reiniciar o Processo",
                        "subtitulo": "Faça o download do arquivo de log para entender como corrigir os problemas ou reinicie o processo abaixo",
                        "titulo-aviso": "O processo de atualização de estoque foi executado, porém houve erro em algumas linhas",
                        "titulo-erro": "Não foi possível realizar a atualização do estoque"
                    },
                    "opcao-1": "CSV (separado por ponto e virgula)",
                    "opcao-2": "TXT (separado por TAB)",
                    "opcao-3": "TXT (posicional)",
                    "subtitulo": "Escolha o Tipo de Arquivo",
                    "sucesso": {
                        "subtitulo": "Em alguns momentos, todo seu estoque estará atualizado",
                        "titulo": "O processo de atualização de estoque foi executado corretamente!"
                    },
                    "titulo": "Passo 1"
                },
                "passo-2": {
                    "arquivo-carregado": "Arquivo carregado: ",
                    "botao": {
                        "limpar": "Clique aqui para recomeçar",
                        "sem-arquivo": "Clique aqui para selecionar um arquivo",
                        "upload": "Confirme o upload"
                    },
                    "dica-transformar-zip": "DICA: Para subir arquivos acima de 4 MB, transforme em .ZIP",
                    "erro": {
                        "corpo": "Você deve realizar o upload de um arquivo",
                        "titulo": "Ops!"
                    },
                    "mensagens": {
                        "erro": {
                            "extensao-invalida": "Extensão do arquivo inválida",
                            "desconhecido": "Falha ao tentar realizar upload deste arquivo",
                            "formato": "Formato do arquivo inválido",
                            "tamanho": "Tamanho do arquivo além do limite de 5MB",
                            "upload-erro": "Ocorreu um erro ao realizar o upload do arquivo"
                        },
                        "sucesso": {
                            "corpo": "Pode seguir para o próximo passo",
                            "titulo": "Colunas selecionadas"
                        },
                        "tamanho": "Tamanho Máximo"
                    },
                    "subtitulo": "Faça o Upload do Arquivo",
                    "titulo": "Passo 2"
                },
                "passo-2-alternativo": {
                    "arquivo-carregado": "Arquivo carregado: ",
                    "botao": {
                        "limpar": "Clique aqui para recomeçar",
                        "sem-arquivo": "Clique aqui para selecionar um arquivo",
                        "upload": "Confirme o upload"
                    },
                    "dica-transformar-zip": "DICA: Para subir arquivos acima de 4 MB, transforme em .ZIP",
                    "erro": {
                        "corpo": "Você deve realizar o upload de um arquivo",
                        "titulo": "Ops!"
                    },
                    "mensagens": {
                        "erro": {
                            "extensao-invalida": "Extensão do arquivo inválida",
                            "desconhecido": "Falha ao tentar realizar upload deste arquivo",
                            "formato": "Formato do arquivo inválido",
                            "tamanho": "Tamanho do arquivo além do limite de 5MB",
                            "upload-erro": "Ocorreu um erro ao realizar o upload do arquivo"
                        },
                        "sucesso": {
                            "corpo": "Pode atualizar seu estoque",
                            "titulo": "Documento Gravado"
                        },
                        "tamanho": "Tamanho Máximo"
                    },
                    "subtitulo": "Faça o Upload do Arquivo",
                    "titulo": "Passo 2"
                },
                "passo-3": {
                    "colunas": {
                        "desconto": {
                            "linear": "Desconto Linear: ",
                            "titulo": "Desconto"
                        },
                        "descricao": {
                            "subtitulo": "(Se não informado será preenchido como vazio)",
                            "titulo": "Descrição"
                        },
                        "marca": {
                            "subtitulo": "(Se não informado será preenchido como \"fabricante não informado\")",
                            "titulo": "Fabricante"
                        },
                        "marca-cod": {
                            "titulo": "Cód Fabricante"
                        },
                        "montadora": {
                            "titulo": "Montadora"
                        },
                        "part-number": "Part Number (Código)",
                        "preco": "Preço",
                        "quantidade": "Quantidade em Estoque",
                        "tipo-peca": {
                            "padrao": "Preenchimento Padrão",
                            "selecione": "Selecione um Tipo",
                            "titulo": "Tipo de Peça"
                        }
                    },
                    "erro": {
                        "repetido": {
                            "corpo": "Você não deve repetir colunas",
                            "titulo": "Ops!"
                        },
                        "obrigatorio": {
                            "corpo": "Você deve preencher todos os campos obrigatórios (* vermelho)",
                            "titulo": "Ops!"
                        }
                    },
                    "subtitulo": "Defina as Colunas",
                    "titulo": "Passo 3"
                },
                "passo-4": {
                    "botao": "Atualizar Estoque",
                    "dados-confirmacao": {
                        "desconto-linear": "Escolhido Desconto Linear",
                        "nome-arquivo": "Nome do Arquivo:",
                        "posicao": "Posição:",
                        "preenchimento-padrao": "Escolhido Preenchimento Padrão",
                        "tipo-arquivo": "Tipo do Arquivo:",
                        "vazio": "<Vazio>",
                        "vazio-marca": "Fabricante Não Informado"
                    },
                    "subtitulo": "Confirme a Atualização de Estoque",
                    "titulo": "Passo 4"
                }
            },
            "titulo": "Atualização de Estoque de Peças",
            "ultima-atualizacao": "Última Atualizacao"
        },
        "configurar-cashback": {
            "botao-salvar": "Salvar",
            "detalhamento": {
                "analise": {
                    "clique-salvar": "Clique aqui para salvar essa alteração",
                    "cashback-efetivo": "Cashback Efetivo",
                    "com-cashback": {
                        "parte-1": "Valor Venda Com Cashback",
                        "parte-2": "(R$ 1000,00 - R$ 700,00)",
                        "parte-3": "Diferença de + "
                    },
                    "desconta-imposto": "Desconta Imposto Sobre a Diferença",
                    "devolve-comprador": "Comprador Recebe",
                    "lucro-extra": "Você Recebe",
                    "margem-extra": "Gera Margem Extra (em %)",
                    "taxa-partsfy": "Partsfy Recebe",
                    "titulo": "Análise"
                },
                "legend": {
                    "titulo": "Detalhamento",
                    "label": "(Exemplo considerando uma peça com valor bruto de R$ 1.000,00)"
                },
                "com": {
                    "desconto": "Desconto",
                    "titulo": "Com Cashback",
                    "valor-peca": "Valor Peça",
                    "valor-venda": "Valor Venda"
                },
                "sem": {
                    "desconto": "Desconto",
                    "titulo": "Sem Cashback",
                    "valor-peca": "Valor Peça",
                    "valor-venda": "Valor Venda"
                }
            },
            "habilitar-cashback": "Cashback Habilitado?",
            "mensagens": {
                "erro": {
                    "carregamento": {
                        "corpo": "Não foi possível carregar os dados de cashback",
                        "titulo": "Operação Não Realizada"
                    },
                    "salvar": {
                        "corpo": "Não foi possível atualizar os dados de cashback",
                        "titulo": "Operação Não Realizada"
                    }
                },
                "sucesso": {
                    "salvar": {
                        "corpo": "Dados de cashback atualizados",
                        "titulo": "Sucesso!"
                    }
                }
            },
            "profit-margin": {
                "label": "Provisionamento",
                "min-max": "(máx: 10%)"
            },
            "titulo": "Configurar Cashback"
        },
        "configurar-fornecimento": {
            "abas": {
                "forma-pagamento": "Forma de Pagamento",
                "frete": "Frete",
                "geral": "Geral",
                "prazo-entrega": "Prazo de Entrega"
            },
            "botoes": {
                "adicionar": "Adicionar",
                "remover": "Remover"
            },
            "forma-pagamento": {
                "colunas": {
                    "forma": "Disponibilizar Forma de Pagamento",
                    "valor-de": "A partir de"
                },
                "mensagens": {
                    "erro": {
                        "adicionar": {
                            "corpo": "Ocorreu um erro ao adicionar esta forma de pagamento",
                            "titulo": "Operação Não Realizada"
                        },
                        "carregamento": {
                            "corpo": "Ocorreu um erro ao carregar os dados da tela",
                            "titulo": "Operação Não Realizada"
                        },
                        "remover": {
                            "corpo": "Ocorreu um erro ao remover os dados desta forma de pagamento",
                            "titulo": "Operação Não Realizada"
                        }
                    },
                    "sucesso": {
                        "adicionar": {
                            "corpo": "Informação de forma de pagamento adicionada com sucesso",
                            "titulo": "Sucesso"
                        },
                        "remover": {
                            "corpo": "Dados de forma de pagamento removidos com sucesso",
                            "titulo": "Sucesso"
                        }
                    }
                },
                "sem-forma": "Não há forma de pagamento",
                "vazio": "Informe os Dados e Adicione as Condições de Forma de Pagamento"
            },
            "frete": {
                "colunas": {
                    "conta-comprador": "Frete por Conta do Comprador",
                    "regiao": "Região",
                    "valor-frete": "Valor do Frete",
                    "valor-minimo-gratis": "Pedido Mínimo para Frete Gratuito"
                },
                "mensagens": {
                    "erro": {
                        "adicionar": {
                            "corpo": "Ocorreu um erro ao adicionar este frete",
                            "titulo": "Operação Não Realizada"
                        },
                        "carregamento": {
                            "corpo": "Ocorreu um erro ao carregar os dados da tela",
                            "titulo": "Operação Não Realizada"
                        },
                        "remover": {
                            "corpo": "Ocorreu um erro ao remover os dados deste frete",
                            "titulo": "Operação Não Realizada"
                        }
                    },
                    "sucesso": {
                        "adicionar": {
                            "corpo": "Informação de frete adicionada com sucesso",
                            "titulo": "Sucesso"
                        },
                        "remover": {
                            "corpo": "Dados de frete removidos com sucesso",
                            "titulo": "Sucesso"
                        }
                    }
                },
                "sem-regiao": "Não há região",
                "vazio": "Informe os Dados e Adicione as Condições de Frete por Região"
            },
            "geral": {
                "aviso-1": "Ao selecionar a configuração abaixo, todas as respostas serão automáticas e sem a revisão do vendedor.",
                "aviso-2": "É possível também que o vendedor revise a cotação. Neste caso a cotação é respondida automaticamente também (para que sua empresa não perca oportunidades), porém o vendedor tem a opção de revisar as condições e reenviar suas condições de venda. Esta configuração evita que sejam realizados ajustes pós-pedido.",
                "label": "Responder Sem Revisão do Vendedor",
                "mensagens": {
                    "erro": {
                        "alterar-dias-pedido-fabrica": {
                            "corpo": "Ocorreu um erro ao alterar o prazo para entrega de fábrica",
                            "titulo": "Operação Não Realizada"
                        },
                        "alterar-resposta-automatica": {
                            "corpo": "Ocorreu um erro ao alterar a opção de resposta automática",
                            "titulo": "Operação Não Realizada"
                        },
                        "carregamento": {
                            "corpo": "Ocorreu um erro ao carregar os dados de fornecimento da holding",
                            "titulo": "Operação Não Realizada"
                        }
                    },
                    "sucesso": {
                        "alterar-dias-pedido-fabrica": {
                            "corpo": "Prazo para entrega de fábrica alterado com sucesso",
                            "titulo": "Sucesso"
                        },
                        "alterar-resposta-automatica": {
                            "corpo": "Opção de resposta automática alterada com sucesso",
                            "titulo": "Sucesso"
                        }
                    }
                }
            },
            "prazo-entrega": {
                "colunas": {
                    "prazo": "Prazo de Entrega Em Estoque (em dias úteis)",
                    "pedido-fabrica": {
                        "du": "dia útil",
                        "dus": "dias úteis",
                        "label": "Fábrica Entrega Em",
                        "ne": "não entrega"
                    },
                    "regiao": "Região"
                },
                "mensagens": {
                    "erro": {
                        "adicionar": {
                            "corpo": "Ocorreu um erro ao adicionar este prazo de entrega",
                            "titulo": "Operação Não Realizada"
                        },
                        "carregamento": {
                            "corpo": "Ocorreu um erro ao carregar os dados da tela",
                            "titulo": "Operação Não Realizada"
                        },
                        "remover": {
                            "corpo": "Ocorreu um erro ao remover os dados deste prazo de entrega",
                            "titulo": "Operação Não Realizada"
                        }
                    },
                    "sucesso": {
                        "adicionar": {
                            "corpo": "Informação de prazo de entrega adicionada com sucesso",
                            "titulo": "Sucesso"
                        },
                        "remover": {
                            "corpo": "Dados de prazo de entrega removidos com sucesso",
                            "titulo": "Sucesso"
                        }
                    }
                },
                "sem-regiao": "Não há região",
                "vazio": "Informe os Dados e Adicione as Condições de Prazo de Entrega por Região"
            },
            "titulo": "Configurar Informações de Fornecimento",
            "tutorial": "Veja um tutorial sobre esta funcionalidade"
        },
        "configurar-rebate": {
            "area-incentivo": {
                "mensagens": {
                    "confirm": "Ao realizar este incentivo, será acrescido x% ao valor pago de comissão por pedido (desta oficina) a {system}. Deseja continuar?",
                    "confirm-remove": "Deseja remover o incentivo a esta oficina?",
                    "erro": {
                        "adicionar-incentivo": {
                            "corpo": "Não foi possível adicionar o incentivo a esta oficina",
                            "titulo": "Operação Não Realizada"
                        },
                        "remover-incentivo": {
                            "corpo": "Não foi possível remover o incentivo desta oficina",
                            "titulo": "Operação Não Realizada"
                        }
                    },
                    "sucesso": {
                        "adicionar-incentivo": {
                            "corpo": "Incentivo adicionado a oficina",
                            "titulo": "Sucesso!"
                        },
                        "remover-incentivo": {
                            "corpo": "Incentivo removido da oficina",
                            "titulo": "Sucesso!"
                        }
                    }
                },
                "subtitulo": "Escolha as oficinas que deseja incentivar ofecerendo um cashback padronizado especial",
                "tabela": {
                    "oficina": "Oficina",
                    "rebate": "Cashback Padronizado"
                },
                "titulo": "Cashback Padronizado Por Oficina",
                "vazio": "Nenhuma oficina está recebendo o incentivo extra"
            },
            "inativo": {
                "botao": "Clique Aqui Para Saber Mais",
                "label": "Ative o cashback padronizado e fidelize mais seus clientes."
            },
            "mensagens": {
                "confirm": "Deseja realmente fazer esta alteração? Caso concorde, será acrescido x% ao valor pago de comissão por pedido a {system}",
                "erro": {
                    "carregamento": {
                        "corpo": "Não foi possível carregar os dados de cashback padronizado",
                        "titulo": "Operação Não Realizada"
                    },
                    "salvar": {
                        "corpo": "Não foi possível atualizar os dados de cashback padronizado",
                        "titulo": "Operação Não Realizada"
                    }
                },
                "sucesso": {
                    "salvar": {
                        "corpo": "Dados de cashback padronizado atualizados",
                        "titulo": "Sucesso!"
                    }
                }
            },
            "subtitulo": "Porcentagem do pedido que será devolvido para a oficina",
            "titulo": "Configurar Cashback Padronizado",
            "valor-padrao": {
                "label": "Cashback Padronizado Padrão",
                "min-max": "(entre 1% e 20%)"
            }
        },
        "gerenciar-vendedores": {
            "baixar-csv": "Baixar CSV",
            "titulo": "Gerenciar Vendedores"
        },
        "relatorio-financeiro": {
            "botao": {
                "contestar": "Contestar",
                "gerar-csv": "Gerar CSV",
                "imprimir": "Imprimir"
            },
            "lista": {
                "cabecalho": {
                    "cnpj": "CNPJ",
                    "custo-comissao": "Comissão",
                    "custo-pedido": "Custo Pedido",
                    "custo-cashback": {
                        "titulo": "Cashback",
                        "mais-detalhes": "Ver Mais Detalhes",
                        "mais-detalhes-rebate": {
                            "p1": "Foi adicionado ",
                            "p2": "% de comissão devido ao cashback padronizado extra dado a esta oficina"
                        }
                    },
                    "data": "Data",
                    "oficina": "Oficina",
                    "pedido": "Pedido",
                    "valor-pedido": "Valor Pedido",
                    "veiculo": "Veículo"
                },
                "detalhes": {
                    "diferenca": "Diferença:",
                    "imposto": "Provisão Cashback",
                    "imposto-info": "O valor provisionado não é repassado para oficina para que possam ser incluídas despesas extras de cashback como comissões, fretes ou impostos",
                    "legend": {
                        "cashback": "Cashback",
                        "rebate": "Cashback Padronizado"
                    },
                    "lucro-extra": "Lucro Extra Recebido:",
                    "rebate-extra": "Cashback Padronizado Extra",
                    "mensagem-consolidada": {
                        "p1": "Você recebeu ",
                        "p2": " a mais e irá repassar "
                    },
                    "repasse": "Repasse Cashback:",
                    "valor-pago": "Valor Vendido:",
                    "valor-peca": "Valor Ofertado (com desconto):"
                },
                "pecas": {
                    "alerta": "O valor referente a peças contestadas será devolvido como reembolso no mês seguinte a contestação",
                    "defina-motivo": "Descreva em poucas palavras o motivo da contestação",
                    "obrigatorio": {
                        "motivo": "O motivo é obrigatório",
                        "peca": "Selecione pelo menos uma peça"
                    },
                    "peca": "Peça",
                    "selecione": "Selecione as peças que deseja contestar",
                    "status": {
                        "aguardando": "Em Análise",
                        "aprovada": "Aprovada"
                    },
                    "valor-cashback": "Cashback",
                    "valor-comissao": "Comissão",
                    "valor-pedido": "Valor Pedido"
                },
                "sem-nf": {
                    "label": "Sem NF",
                    "tooltip-pedido": "Pedido",
                    "tooltip-ver": "Clique para ver a NF"
                },
                "total": "Total"
            },
            "mensagens": {
                "erro": {
                    "contestar": {
                        "corpo": "Não foi possível realizar esta contestação",
                        "titulo": "Operação Não Realizada"
                    },
                    "carregamento-dados-holding": {
                        "corpo": "Não foi possível carregar os dados da empresa",
                        "titulo": "Operação Não Realizada"
                    },
                    "carregamento-meses": {
                        "corpo": "Não foi possível carregar os últimos 6 meses",
                        "titulo": "Operação Não Realizada"
                    },
                    "carregamento-nota-fiscal": {
                        "corpo": "Não foi possível carregar esta nota fiscal. Tente atualizar a tela ou entre em contato com o suporte.",
                        "titulo": "Operação Não Realizada"
                    },
                    "carregamento-relatorio": {
                        "corpo": "Não foi possível carregar o relatório deste mês",
                        "titulo": "Operação Não Realizada"
                    }
                },
                "sucesso": {
                    "contestar": {
                        "corpo": "Contestação realizada com sucesso",
                        "titulo": "Sucesso!"
                    }
                }
            },
            "subtitulo": {
                "pedidos": "Relação de Pedidos Criados",
                "oportunidades": "Relação de Oportunidades Criadas",
                "comissoes": "Relação de Pedidos Criados"
            },
            "sumario": {
                "titulo": "Sumário",
                "cashback": "Repasse Cashback",
                "mensalidade": "Mensalidade",
                "pedidos": "Pedidos",
                "oportunidades": "Nro Oportunidades",
                "custo-cotacao": "Custo da Cotação",
                "custo-comissao": "Comissão",
                "reembolso": "Reembolso",
                "total": "Total"
            },
            "titulo": {
                "pedidos": "Relatório Mensal de Pedidos - ",
                "oportunidades": "Relatório Mensal de Cotações - ",
                "comissoes": "Relatório Mensal de Pedidos - "
            },
            "vazio": {
                "pedidos": "Nenhum Pedido foi Encontrado no Período Selecionado",
                "oportunidades": "Nenhuma Oportunidade foi Encontrada no Período Selecionado",
                "comissoes": "Nenhum Pedido foi Encontrado no Período Selecionado"
            }
        }
    },
    "repairer-manager": {
        "cashback": {
            "atualizar": "Atualizar Tela",
            "historico": {
                "desabilitar": "Ocultar Histórico de Transações",
                "filtro-fornecedor": "Pesquise Pelo Fornecedor",
                "filtro-lancamentos": {
                    "disponivel": "Disponível Resgate",
                    "pendente": "Pendente Liberação",
                    "resgate-efetuado": "Já Resgatado",
                    "resgate-solicitado": "Resgate Solicitado",
                    "todos": "Todos Lançamentos"
                },
                "filtro-periodo": {
                    "mais-antigos": "Mais Antigos",
                    "ultimos-30": "Últimos 30 dias",
                    "ultimos-60": "Últimos 60 dias",
                    "ultimos-90": "Últimos 90 dias"
                },
                "habilitar": "Ver Histórico de Transações",
                "limpar": "Limpar",
                "titulo": "Histórico de Transações",
                "transacao": {
                    "data-compra": "Data Compra",
                    "data-liberacao": "Data Liberação",
                    "data-resgate": "Data Resgate",
                    "data-resgate-solicitacao": "Data Solicitação",
                    "desconto-mensalidade": "Cashback descontado da mensalidade",
                    "desconto-mensalidade-mes": "Mês Referência",
                    "pedido": "Pedido",
                    "status": "Status",
                    "status-ja-pago": "Já Pago",
                    "veiculo": "Veículo"
                },
                "vazio": "Não foi encontrada nenhuma transação"
            },
            "mensagens": {
                "erro": {
                    "carregamento": {
                        "corpo": "Não foi possível listar as transações com cashback",
                        "titulo": "Operação Não Realizada"
                    },
                    "solicitar-resgate": {
                        "corpo": "Não foi possível solicitar o resgate",
                        "titulo": "Operação Não Realizada"
                    }
                },
                "sucesso": {
                    "solicitar-resgate": {
                        "corpo": "Solicitação de Resgate efetuada",
                        "titulo": "Operação Realizada"
                    }
                }
            },
            "solicitar-resgate": {
                "botao": {
                    "confirmar": "Continuar",
                    "fechar": "Não"
                },
                "custo-retirada": "Custo de Retirada:",
                "prazo-pagamento": {
                    "parte-1": "O pagamento será efetuado em até",
                    "parte-2": "dias úteis"
                },
                "titulo": "Confira se está tudo correto:",
                "valor-receber": "Valor A Receber:",
                "valor-solicitado": "Valor Solicitado:"
            },
            "subtitulo": "Acompanhe aqui seu Cashback na Partsfy!",
            "titulo": "Seu Cashback",
            "widget": {
                "disponivel": {
                    "botao": "Solicitar Resgate",
                    "titulo": "Disponível Para Resgatar",
                    "valor-minimo": "Valor mínimo para resgate"
                },
                "pendente": {
                    "titulo": "Pendente de Liberação"
                },
                "pendente-resgate": {
                    "titulo": "Aguardando Pagamento:"
                },
                "solicitado": {
                    "titulo": "Créditos Já Resgatados"
                }
            }
        },
        "configuracoes": {
            "titulo": "Configurações de Sua Oficina",
            "auditoria_compras": "Auditoria de Compras",
            "botoes": {
                "salvar": "Salvar"
            },
            "limite_minimo_auditoria": {
                "label": "Limite Mínimo",
                "obrigatorio": "O limite mínimo é obrigatório e deve ser maior ou igual a R$ 10,00"
            },
            "mensagens": {
                "sucesso": {
                    "titulo": "Sucesso!",
                    "titulo-envio": "Enviado com sucesso",
                    "corpo": "Configurações salvas com sucesso"
                },
                "erro": {
                    "titulo": "Erro ao salvar",
                    "corpo": "Ocorreu um erro ao salvar.",
                    "carregamento": {
                        "titulo": "Erro Desconhecido",
                        "corpo": "Não foi possível carregar as configurações"
                    }
                }
            }
        }
    },
    "seller": {
        "cockpit": {
            "atualizar": "Atualizar Tela",
            "grafico": {
                "market-share": {
                    "y": "Market Share",
                    "titulo": "Market Share"
                },
                "vendas": {
                    "y": "Suas Vendas",
                    "titulo": "Vendas"
                }
            },
            "market-share": "Market Share é o percentual das suas vendas em relação ao total de vendas realizadas na plataforma",
            "mensagens": {
                "erro": {
                    "carregamento": {
                        "corpo": "Houve um erro ao carregar o cockpit",
                        "titulo": "Operação Não Realizada"
                    },
                    "carregamento-detalhe": {
                        "corpo": "Houve um erro ao carregar o detalhamento deste período",
                        "titulo": "Operação Não Realizada"
                    }
                }
            },
            "tabela": {
                "cabecalho": {
                    "detalhe": {
                        "oportunidades": "Oportunidades",
                        "perdidas": {
                            "tooltip": "Oportunidades Que Nem Respondeu Nem Recusou (% Perda)",
                            "titulo": "Perdidas"
                        },
                        "recusadas": "Recusadas",
                        "respondidas": {
                            "tooltip": "Oportunidades Respondidas (% Aproveitamento)",
                            "titulo": "Respondidas"
                        },
                        "valor-perdido": {
                            "tooltip": "Valor Vendido Nas Oportunidades Perdidas",
                            "titulo": "Valor Perdido"
                        },
                        "valor-vendido": "Valor Vendido",
                        "vendedor": "Vendedor"
                    },

                    "aproveitamento": "Aproveitamento de Oportunidades",
                    "market-share": "Market Share",
                    "mes": "Mês",
                    "respondidas": "Oportunidades Respondidas",
                    "suas-vendas": "Suas Vendas",
                    "total-oportunidades": "Total de Oportunidades",
                    "total-vendas": {
                        "tooltip": "Este valor corresponde ao total de vendas que foram realizadas pela plataforma",
                        "titulo": "Total de Vendas"
                    }
                }
            }
        },
        "configurar-condicoes-fornecimento": {
            "mensagens": {
                "erro": {
                    "carregamento": {
                        "corpo": "Não foi possível carregar os dados da tela",
                        "titulo": "Operação Não Realizada"
                    },
                    "ja-preenchido": {
                        "corpo": "As condições de fornecimento já foram preenchidas",
                        "titulo": "Ops"
                    },
                    "salvar": {
                        "corpo": "Não foi possível salvar as condições de fornecimento",
                        "titulo": "Operação Não Realizada"
                    }
                },
                "sucesso": {
                    "salvar": {
                        "corpo": "Condições de fornecimento salvas com sucesso",
                        "titulo": "Operação Realizada"
                    }
                }
            },
            "passos": {
                "botoes": {
                    "adicionar": "Adicionar",
                    "remover": "Remover"
                },
                "passo-1": {
                    "colunas": {
                        "forma": "Disponibilizar Forma de Pagamento",
                        "valor-de": "A partir de"
                    },
                    "erro": {
                        "corpo": "Você deve selecionar ao menos uma forma de pagamento",
                        "titulo": "Ops!"
                    },
                    "exemplo": "Ex: Libere pagamentos em 30 dias para compras a partir de R$ 100,00 ou em 30/60/90 a partir de R$ 400,00. E assim por diante",
                    "sem-forma": "Não há forma de pagamento",
                    "subtitulo": "Configure as formas de pagamento",
                    "titulo": "Forma de Pagamento",
                    "vazio": "Informe os Dados e Adicione as Condições de Forma de Pagamento"
                },
                "passo-2": {
                    "colunas": {
                        "conta-comprador": "Frete por Conta do Comprador",
                        "regiao": "Região",
                        "valor-frete": "Valor do Frete",
                        "valor-minimo-gratis": "Pedido Mínimo para Frete Gratuito"
                    },
                    "erro": {
                        "corpo": "Você deve selecionar ao menos uma condição de frete",
                        "titulo": "Ops!"
                    },
                    "exemplo": "Defina o valor mínimo para frete gratuito e o custo do frete para cada região de entrega",
                    "sem-regiao": "Não há região",
                    "subtitulo": "Configure as condições de frete",
                    "titulo": "Frete",
                    "vazio": "Informe os Dados e Adicione as Condições de Frete por Região"
                },
                "passo-3": {
                    "colunas": {
                        "regiao": "Região",
                        "pedido-fabrica": {
                            "du": "dias úteis",
                            "label": "Fábrica Entrega Em"
                        },
                        "prazo": "Prazo de Entrega (em dias)"
                    },
                    "erro": {
                        "corpo": "Você deve selecionar ao menos uma condição de prazo de entrega",
                        "titulo": "Ops!"
                    },
                    "erro-dias": {
                        "corpo": "Você deve definir o tempo que demora para a peça chegar em um pedido de fábrica",
                        "titulo": "Ops!"
                    },
                    "exemplo": "Defina o tempo (em dias úteis) necessário para entrega em cada região",
                    "sem-regiao": "Não há região",
                    "subtitulo": "Configure o prazo de entrega por região",
                    "titulo": "Prazo de Entrega",
                    "vazio": "Informe os Dados e Adicione as Condições de Prazo de Entrega por Região"
                },
                "passo-4": {
                    "botao": "Confirmar",
                    "exemplo": "Clique no botão de confirmar para salvar as condições de fornecimento",
                    "subtitulo": "Confirme as condições de fornecimento",
                    "titulo": "Confirmação"
                }
            },
            "titulo": "Configure Suas Condições de Fornecimento"
        },
        "dashboard": {
            "cabecalho": {
                "texto-cotacao": {
                    "singular": "COTAÇÃO",
                    "plural": "COTAÇÕES",
                    "nenhuma": "NENHUMA COTAÇÃO"
                },
                "texto-pedido": {
                    "singular": "PEDIDO",
                    "plural": "PEDIDOS",
                    "nenhuma": "NENHUM PEDIDO"
                },
                "fases": {
                    "em-cotacao": "Em Cotação",
                    "aguardando-confirmacao": "Aguardando Confirmação",
                    "aguardando-entrega": "Aguardando Entrega",
                    "pedidos-entregues": "Pedidos Finalizados"
                }
            },
            "colunas": {
                "titulos": {
                    "aguardando-entrega": "Aguardando Entrega",
                    "atrasado": "Atrasado",
                    "confirmacao": "Aguardando Confirmação",
                    "despachado": "Despachado",
                    "entrega-amanha": "Entrega Amanhã",
                    "entrega-hoje": "Entrega Hoje",
                    "em-analise": "Em Análise",
                    "ultimos-pedidos": "Pedidos dos Últimos 7 dias"
                }
            },
            "cards": {
                "cashback": "Oportunidade de Cashback",
                "cashback-pedido": "Pedido com Cashback",
                "nota": {
                    "inserir": "Inserir XML Nota Fiscal"
                },
                "mais-detalhes": "+ Detalhes",
                "nenhum-pedido-encontrado": "NENHUM PEDIDO FOI ENCONTRADO",
                "nenhuma-cotacao-encontrada": "NENHUMA COTAÇÃO FOI ENCONTRADA",
                "data-cotacao": "Data Cotação",
                "data-pedido": "Data Pedido",
                "status": {
                    "aguardando-confirmacao": "AGUARDANDO CONFIRMAÇÃO",
                    "em-analise": "EM ANÁLISE",
                    "aguardando-entrega": {
                        "entrega": "ENTREGA",
                        "hoje": "HOJE",
                        "amanha": "AMANHÃ",
                        "atrasada": "ATRASADA"
                    }
                },
                "tem-devolucao": "Tem Devolução",
                "tem-troca": "Tem Troca"
            },
            "colocar-analise": {
                "titulo": "Colocar pedido em análise",
                "subtitulo": "Veículo: ",
                "legenda": "Selecione o motivo de colocar o pedido em análise",
                "botao": {
                    "cancelar": "Cancelar",
                    "rejeitar": "Colocar em análise"
                },
                "notes-erro": {
                    "titulo": "Preencha todos os campos",
                    "corpo": "Você deve preencher o campo de observação antes de prosseguir"
                }
            },
            "detalhes": {
                "botao": {
                    "cancelar-entrega": "Cancelar Entrega",
                    "confirmar-entrega": "Confirmar Entrega",
                    "confirmar-pedido": "Confirmar Pedido",
                    "confirmar-pedido-a-vista": {
                        "faturar": "Sim, faturar na forma escolhida",
                        "manter": "Não, manter como está"
                    },
                    "confirmar-rejeitar": "Rejeitar Peças Selecionadas",
                    "em-analise": "Colocar Em Análise",
                    "fechar": "Fechar",
                    "fotos": "Fotos do Veículo",
                    "imprimir": "Imprimir",
                    "notas-fiscais": "Notas Fiscais",
                    "rejeitar": "Rejeitar Peças",
                    "responder": "Responder Cotação",
                    "voltar": "Voltar"
                },
                "confirmar": {
                    "titulo": "Deseja realmente confirmar a entrega deste pedido?",
                    "botao": {
                        "fechar": "Fechar",
                        "confirmar": "Confirmar"
                    },
                    "sucesso": {
                        "titulo": "Pedido Confirmado",
                        "corpo": "Operação realizada com sucesso"
                    }
                },
                "confirmar-entrega": {
                    "confirm": "Deseja realmente confirmar a entrega desta(s) peça(s)?",
                    "sucesso": {
                        "titulo": "Entrega Confirmada",
                        "corpo": "Operação realizada com sucesso"
                    },
                    "status": "Peça entregue"
                },
                "dados-pedido": "Dados do Pedido",
                "fotos": {
                    "titulo": "Fotos do Veículo",
                    "esconder": "Fotos do Veículo ( Clique para esconder )",
                    "ver-mais": "Fotos do Veículo ( Clique para ver mais )"
                },
                "informacoes": {
                    "cabecalho": {
                        "alerta-conferencia": "IMPORTANTE: Confira a compatibilidade das peças com o chassi/fotos do veículo para evitar erros na entrega.",
                        "cnpj": "CNPJ",
                        "cashback": "Oportunidade de Cashback",
                        "cashback-pedido": "Pedido com Cashback",
                        "chassi": "Chassi do Automóvel",
                        "chassi-menor": "Chassi",
                        "cod-orcamento": "Código",
                        "condicoes-fornecimento": "Defina suas condições de fornecimento",
                        "data-pedido": "Data do Pedido",
                        "endereco": "Endereço",
                        "forma-pagamento": "Forma de Pagamento",
                        "observacao-comprador": "Observações do Comprador",
                        "selecione-pecas": "Selecione as Peças Para Fornecer",
                        "solicitado": "Orçamento Solicitado Por",
                        "solicitado-pedido": "Pedido Feito Por",
                        "telefone": "Telefone",
                        "tipos-pecas": "Tipos das Peças",
                        "tipos-pecas-menor": "Tipos"
                    }
                },
                "mensagens": {
                    "confirm": {
                        "confirmar-pedido-a-vista": {
                            "erro": "Selecione uma forma de pagamento",
                            "placeholder": "Selecione uma forma de pagamento",
                            "titulo": "Deseja aprovar crédito para essa oficina e faturar este pedido?"
                        }
                    },
                    "erro": {
                        "carregamento": {
                            "titulo": "Pedido Não Encontrado",
                            "corpo": "Não foi possível carregar os dados deste pedido",
                            "nao-encontrado": "O pedido #xxx não foi encontrado",
                            "sem-codigo": "O código deste pedido está inválido."
                        },
                        "carregamento-nota-fiscal": {
                            "corpo": "Não foi possível carregar esta nota fiscal. Tente atualizar a tela ou entre em contato com o suporte.",
                            "titulo": "Operação Não Realizada"
                        },
                        "confirmar-entrega": {
                            "titulo": "Operação não realizada",
                            "corpo": "Ocorreu um erro ao tentar confirmar entrega de uma ou mais peças"
                        },
                        "confirmar-pedido": {
                            "titulo": "Operação não realizada",
                            "corpo": "Ocorreu um erro ao confirmar o pedido"
                        },
                        "em-analise": {
                            "titulo": "Operação não realizada",
                            "corpo": "Ocorreu um erro ao colocar em análise"
                        },
                        "rejeitar-entrega": {
                            "titulo": "Operação não realizada",
                            "corpo": "Ocorreu um erro ao tentar rejeitar entrega de uma ou mais peças"
                        },
                        "rejeitar-peca": {
                            "titulo": "Operação não realizada",
                            "corpo": "Ocorreu um erro ao tentar rejeitar uma ou mais peças"
                        }
                    },
                    "sucesso": {
                        "confirmar-entrega": {
                            "titulo": "Entrega Confirmada",
                            "corpo": "Operação realizada com sucesso"
                        },
                        "confirmar-pedido": {
                            "titulo": "Operação realizada com sucesso",
                            "corpo": "Este pedido foi confirmado com sucesso"
                        },
                        "em-analise": {
                            "titulo": "Operação realizada com sucesso",
                            "corpo": "Este pedido foi colocado em análise"
                        },
                        "rejeitar-entrega": {
                            "titulo": "Operação realizada com sucesso",
                            "corpo": "A entrega de uma ou mais peças foi rejeitada com sucesso"
                        },
                        "rejeitar-peca": {
                            "titulo": "Operação realizada com sucesso",
                            "corpo": "Uma ou mais peças foram rejeitas com sucesso"
                        }
                    }
                },
                "notas-fiscais": {
                    "titulo": "Notas Fiscais do Pedido #"
                },
                "numero-pedido": "Pedido",
                "data-pedido": "Data Pedido",
                "em-analise": {
                    "titulo": "Deseja realmente colocar este pedido em análise?",
                    "botao": {
                        "fechar": "Fechar",
                        "confirmar": "Confirmar"
                    },
                    "sucesso": {
                        "titulo": "Pedido Em Análise",
                        "corpo": "Operação realizada com sucesso"
                    }
                },
                "rejeitar": {
                    "botao": {
                        "aberto": "Rejeitar Peças",
                        "rejeitar": "Rejeitar Peças Selecionadas"
                    },
                    "confirm": "Deseja realmente rejeitar a(s) peça(s) selecionada(s)?",
                    "label-aberto": "Deseja rejeitar alguma peça?",
                    "status": "Peça rejeitada"
                },
                "tabela": {
                    "desconto": "% Desc.",
                    "peca": "Peça",
                    "prazo": {
                        "label": "Prazo de Entrega",
                        "tooltip": "Em Dias Úteis"
                    },
                    "quantidade": "Qtd.",
                    "status": "Status",
                    "tipo-peca": "Tipo de Peça",
                    "total": "Total",
                    "valor": "Vlr Unit.",
                    "previsao-entrega": "Previsão de Entrega",
                    "rejeitar": "Rejeitar",
                    "rodape": {
                        "total": "Total",
                        "frete": {
                            "label": "Frete",
                            "nao-entregamos": "Não entregamos",
                            "conta-comprador": "Por conta do comprador"
                        },
                        "total-pecas": "Total (Peças)"
                    }
                }
            },
            "filtro": "Digite aqui sua busca. Veículo / Placa (Formato: XXX-1234) / Oficina",
            "mensagens": {
                "erro": {
                    "titulo": "Ocorreu um erro",
                    "corpo": "Operação não realizada"
                },
                "comprar": {
                    "sucesso": {
                        "titulo": "Compra Efetuada",
                        "corpo": "Operação realizada com sucesso"
                    }
                },
                "listar": {
                    "erro": {
                        "titulo": "Cotação Não Encontrada",
                        "nao-encontrada": "A cotação #xxx não foi encontrada ou já se tornou um pedido.",
                        "sem-codigo": "O código desta cotação está inválido."
                    }
                },
                "reabrir": {
                    "sucesso": {
                        "titulo": "Cotação Re-aberta",
                        "corpo": "Operação realizada com sucesso"
                    }
                }
            },
            "responder": {
                "botao": {
                    "fechar": "Fechar",
                    "nao-quero": "Não quero participar desta cotação",
                    "rejeitar": "Rejeitar Peças",
                    "responder": "Responder Cotação"
                },
                "condicoes-fornecimento": {
                    "configurar": {
                        "botoes": {
                            "confirmar": "Configurar Agora",
                            "fechar": "Deixar para Depois"
                        },
                        "subtitulo": ", para facilitar sua vida, criamos uma nova forma de configurar suas condições de fornecimento",
                        "titulo": "Configure suas Condições de Fornecimento"
                    },
                    "info": {
                        "nao-pagante": {
                            "p-1": "** Caso suas condições de fornecimento estejam erradas, ",
                            "p-2": "clique aqui",
                            "p-3": " para avisar o suporte **"
                        },
                        "pagante": "** Caso suas condições de fornecimento estejam erradas, favor comunicar seu gestor **"
                    },
                    "modal": {
                        "condicoes": {
                            "abas": {
                                "forma-pagamento": "Forma de Pagamento",
                                "frete": "Frete",
                                "prazo-entrega": "Prazo de Entrega"
                            },
                            "forma-pagamento": {
                                "colunas": {
                                    "forma": "Forma Pagamento",
                                    "valor-de": "Valor Mínimo"
                                },
                                "vazio": "Nenhuma forma de pagamento foi configurada"
                            },
                            "frete": {
                                "colunas": {
                                    "conta-comprador": "Por Conta Comprador",
                                    "regiao": "Região",
                                    "valor-frete": "Valor Frete",
                                    "valor-minimo-gratis": "Pedido Mínimo (Frete Grátis)"
                                },
                                "vazio": "Nenhuma condição de frete foi configurada"
                            },
                            "prazo-entrega": {
                                "colunas": {
                                    "prazo": "Prazo de Entrega",
                                    "regiao": "Região"
                                },
                                "vazio": "Nenhuma condição de prazo de entrega foi configurada"
                            }
                        },
                        "titulo": "Condições de Fornecimento Configuradas"
                    },
                    "visualizar": "Veja aqui as condições de fornecimento configuradas"
                },
                "faturamento-liberado": {
                    "label": "Faturamento Liberado?",
                    "digite-aqui": "Digite o valor do limite",
                    "nao-liberado": {
                        "label-1": "Este cliente tem faturamento liberado em sua empresa?",
                        "label-2": {
                            "p1": "Clique",
                            "p2": "aqui",
                            "p3": "e informe"
                        },
                        "label-3": "Assim você poderá responder com opções de faturamento nesta cotação e nas próximas!",
                        "label-4": "Este cliente está com o faturamento bloqueado. Acesse a plataforma em seu computador para liberar outras formas de pagamento.",
                        "dados": {
                            "cancelar": "Cancelar",
                            "salvar": "Salvar",
                            "titulo": "Limite Disponível"
                        },
                        "mensagens": {
                            "erro": {
                                "titulo": "Ocorreu um erro",
                                "corpo": "Operação não realizada"
                            },
                            "sucesso": {
                                "titulo": "Limite Alterado",
                                "corpo": "Operação realizada com sucesso"
                            }
                        }
                    }
                },
                "forma-pagamento": {
                    "label": "Forma de Pagamento",
                    "label-a-vista": "Somente à vista ou no cartão (verificar disponibilidade)",
                    "label-a-vista-2": "Pagamento à vista ou no cartão (verificar disponibilidade)",
                    "label-em-ate": "Em até"
                },
                "fotos": {
                    "esconder": "Fotos do Veículo ( Clique para esconder )",
                    "ver-mais": "Fotos do Veículo ( Clique para ver mais )"
                },
                "frete": {
                    "conta-comprador": "Frete a cobrar (por conta do comprador)",
                    "entrega-regiao": "para entrega na região da oficina",
                    "gratuito": "Frete gratuito",
                    "label": "Condições de Frete",
                    "valor-frete": "Valor do Frete:"
                },
                "frete-gratuito": {
                    "label": "Frete Gratuito?",
                    "digite-aqui": "Digite o valor do frete",
                    "nao-entregamos": "Não entregamos",
                    "conta-comprador": "Frete a cobrar (por conta do comprador)",
                    "valor": "Valor"
                },
                "mensagens": {
                    "erro": {
                        "carregamento": {
                            "titulo": "Operação não realizada",
                            "corpo": "Não foi possível carregar os dados desta cotação"
                        },
                        "limite-credito": {
                            "titulo": "Operação não realizada",
                            "corpo": "Não foi possível salvar o limite de crédito deste comprador"
                        },
                        "nao-participar": {
                            "titulo": "Operação não realizada",
                            "corpo": "Não foi possível decidir não participar desta cotação"
                        },
                        "participar": {
                            "titulo": "Operação não realizada",
                            "corpo": "Não foi possível participar desta cotação. Tente novamente"
                        }
                    },
                    "sucesso": {
                        "copiar-codigo": {
                            "corpo": "Código copiado!"
                        },
                        "limite-credito": {
                            "titulo": "Operação realizada com sucesso",
                            "corpo": "Agora você pode alterar as opções de faturamento"
                        },
                        "nao-participar": {
                            "titulo": "Operação realizada com sucesso",
                            "corpo": "Você decidiu não participar desta cotação"
                        },
                        "participar": {
                            "titulo": "Operação realizada com sucesso",
                            "corpo": "Você já está participando da cotação"
                        }
                    }
                },
                "nao-participar": {
                    "subtitulo": "Por que você não deseja participar dessa Cotação?",
                    "selecione": "Selecione um motivo",
                    "selecione-erro": "Você deve selecionar um motivo",
                    "botao": {
                        "fechar": "Fechar",
                        "responder": "Enviar meu feedback"
                    },
                    "sucesso": {
                        "titulo": "Feito!",
                        "corpo": "Operação realizada com sucesso"
                    }
                },
                "observacao": {
                    "label": "Notas para Comprador"
                },
                "participar": {
                    "titulo": "Deseja realmente responder esta cotação?",
                    "botao": {
                        "fechar": "Fechar",
                        "responder": "Confirmar"
                    },
                    "erros": {
                        "titulo": "Verifique sua resposta antes de prosseguir",
                        "faturamento-indefinido": "Definir o limite de faturamento acima de R$ 0,00",
                        "frete": {
                            "indefinido": "O tipo de frete deve ser definido",
                            "dados-invalidos": "Ajustar os dados de frete"
                        },
                        "forma-pagamento-indefinido": "Deve-se definir uma forma de pagamento",
                        "peca": {
                            "prazo-entrega-invalido": "O prazo de entrega deve ser selecionado",
                            "preco-invalido": "O preço da peça deve ser maior do que R$ 0,00",
                            "tipo-peca": {
                                "invalido": "O tipo da peça deve ser selecionado",
                                "marca-invalida": "Uma marca deve ser definida para este tipo de peça"
                            },
                            "quantidade-em-estoque-invalido": "A quantidade em estoque deve ser maior do que 0"
                        },
                        "pelo-menos-uma-peca": "Pelo menos uma peça deve ter seus campos preenchidos"
                    },
                    "sucesso": {
                        "titulo": "Cotação Respondida",
                        "corpo": "Operação realizada com sucesso"
                    }
                },
                "passos": {
                    "passo-1": {
                        "cabecalho": {
                            "tabela": {
                                "peca-nome": "(Qtd) - Peça",
                                "quantidade": "Qtd"
                            }
                        },
                        "campos":{
                            "quantidade-em-estoque":"Qtd em estoque"
                        }
                    },
                    "passo-2": {
                        "campos": {
                            "codigo": "Código",
                            "desconto": "% Desconto",
                            "marca": "Marca",
                            "prazoentrega": "Prazo de Entrega",
                            "quantidade": "Quantidade de Peças",
                            "tipopeca": "Tipo de Peça",
                            "total": "Total",
                            "valor": "Valor Unitário"
                        },
                        "erros": {
                            "desconto": "A % de desconto deve ser preenchido",
                            "valor": "O valor unitário deve ser preenchido e ser maior do que 0"
                        }
                    }
                },
                "tabela": {
                    "opcao-responder": {
                        "quero": "Clique aqui para responder esta peça",
                        "nao-quero": "Não quero mais responder esta peça"
                    },
                    "codigo": {
                        "label": "Código",
                        "tooltip": "Somente atualize se o código estiver errado"
                    },
                    "desconto": "% Desconto",
                    "desconto-2": "% Desc.",
                    "marca": "Marca",
                    "peca": "Peça",
                    "prazo": {
                        "label": "Prazo de Entrega",
                        "tooltip": "Em Dias Úteis"
                    },
                    "quantidade": "Qtd.",
                    "tipo-peca": "Tipo de Peça",
                    "total": "Total",
                    "valor": "Vlr Unit.",
                    "quantidade-em-estoque": "Qt em estoque",
                    "rodape": {
                        "total": "Total"
                    }
                }
            },
            "rejeitar-peca": {
                "titulo": "Rejeitar peças",
                "subtitulo": "Veículo: ",
                "legenda": "Selecione o motivo da rejeição da peças",
                "botao": {
                    "cancelar": "Cancelar",
                    "rejeitar": "Rejeitar peças"
                },
                "notes-erro": {
                    "titulo": "Preencha todos os campos",
                    "corpo": "Você deve preencher o campo de observação antes de prosseguir"
                }
            }
        },
        "documentacao": {
            "coluna-1": {
                "filtro": "Pesquise por Oficina, CNPJ ou Status e aperte enter...",
                "ordenar-vendas": "Ordenado Por Total Vendas",
                "tabela": {
                    "header": {
                        "empresa": "Empresa",
                        "cidade": "Cidade",
                        "situacao": "Situação"
                    },
                    "botoes": {
                        "analisar": "Analisar Cadastro",
                        "editar": "Editar"
                    },
                    "status": {
                        "aprovado": "Aprovado",
                        "rejeitado": "Rejeitado",
                        "pendente": "Pendente"
                    },
                    "vazio": "Você não tem nenhum cliente em sua carteira"
                }
            },
            "coluna-2": {
                "empresa": "Empresa",
                "cnpj": "CNPJ",
                "cidade": "Cidade",
                "documentacao": {
                    "titulo": "Baixar Documentação",
                    "nao-existe": "Sem Documentação",
                    "download": "Download Aqui"
                },
                "informacoes-mercado": {
                    "titulo": "INFORMAÇÕES DO MERCADO",
                    "cadastro-aprovado": "Cadastro Aprovado em:",
                    "empresa-singular": "empresa",
                    "empresa-plural": "empresas",
                    "limite-medio": "Limite Médio:"
                },
                "taxa-aprovacao": {
                    "titulo": "Taxa de Aprovação de Cadastros",
                    "informativo": "A taxa de aprovação de cadastro mede a % de aprovações dentro do total de análises realizada"
                },
                "situacao-cadastro": {
                    "titulo": "SITUAÇÃO DO CADASTRO EM MINHA EMPRESA",
                    "status": "Status:",
                    "limite-disponivel": {
                        "label": "Limite Disponível:",
                        "obrigatorio": "Este campo é obrigatório e deve ser maior do que zero"
                    },
                    "salvar": {
                        "botao": "Salvar",
                        "sucesso": {
                            "titulo": "Salvo com sucesso",
                            "corpo": "Operação realizada com sucesso."
                        }
                    },
                    "cancelar": "Cancelar"
                }
            },
            "alerta-modo-edicao": {
                "titulo": "Outro Cliente em Modo Edição",
                "corpo": "Salve ou cancele a edição do outro cliente antes de alterar este"
            }
        },
        "notas-fiscais": {
            "panel": {
                "dados-comprador": {
                    "comprador-empresa": "Comprador (Oficina)",
                    "fone": "Fone"
                },
                "inconsistencias": {
                    "texto": "Inconsistência"
                },
                "pecas": {
                    "entrega": "Entrega",
                    "nome": "Peça",
                    "quantidade": "Qtd",
                    "vendedor-preco": "Preço",
                    "vendedor-total": "Total"
                },
                "titulo": {
                    "dados-comprador": "Dados Comprador",
                    "inconsistencia": "Inconsistências",
                    "peca": "Peças"
                },
                "total-pedido": "Valor Pedido"
            },
            "titulo": "Notas Fiscais -"
        },
        "nota-fiscal": {
            "mensagens": {
                "confirm": {
                    "excluir": "Deseja realmente remover esta nota fiscal?"
                },
                "erro": {
                    "excluir": {
                        "corpo": "Houve um erro ao excluir esta nota fiscal",
                        "titulo": "Erro!"
                    },
                    "incluir": {
                        "corpo": "Ocorreu um erro ao tentar gravar sua nota fiscal",
                        "titulo": "Nota Não Inserida"
                    },
                    "incluir-extensao": {
                        "corpo": "Somente arquivos XML são permitidos",
                        "titulo": "Nota Não Inserida"
                    }
                },
                "sucesso": {
                    "excluir": {
                        "corpo": "Nota fiscal excluída com sucesso",
                        "titulo": "Sucesso!"
                    },
                    "incluir": {
                        "corpo": "Sua nota fiscal foi inserida com sucesso",
                        "titulo": "Nota Inserida Com Sucesso"
                    }
                }
            }
        },
        "pedidos": {
            "filtro": {
                "botao": "Pesquisar",
                "periodo": {
                    "todos": "Todos",
                    "ultimos-15": "Últimos 15 dias"
                },
                "placeholder": "Digite aqui sua busca. Veículo / Placa / Chassi / Nro Pedido"
            },
            "mensagens": {
                "sem-pedido": {
                    "inicial": "Digite os dados do veículo e clique em pesquisar para encontrar seu pedido",
                    "filtrado": "Nenhum pedido foi encontrado com este filtro"
                },
                "erro": {
                    "carregamento": {
                        "corpo": "Ocorreu um erro desconhecido",
                        "titulo": "Erro ao Realizar Pesquisa"
                    }
                }
            },
            "fotos": {
                "esconder": "Fotos do Veículo ( Clique para esconder )",
                "ver-mais": "Fotos do Veículo ( Clique para ver mais )"
            },
            "responder": {
                "buscar-peca": {
                    "pergunta": "Deseja buscar a informação desta peça em seu estoque?",
                    "peca-encontrada-estoque-zero": "Dados da peça encontrados, porém sem estoque",
                    "peca-encontrada-estoque-menor": "Dados da peça encontrados, porém com estoque menor do que o solicitado",
                    "peca-nao-encontrada": "Peça não encontrada no estoque",
                    "peca-erro": "Erro ao buscar a peça no estoque"
                }
            }
        }
    },
    "support": {
        "avaliacao-vendedores": {
            "lista": {
                "cabecalho": {
                    "fornecedor": "Fornecedor",
                    "pedidos": "Pedidos",
                    "taxa-avaliacao": "Avaliação",
                    "taxa-entrega-prazo": "Entrega no Prazo",
                    "tipos": "total (últimos 90d)",
                    "vendedor": "Vendedor"
                },
                "mensagens": {
                    "erro": {
                        "carregamento-avaliacao": {
                            "corpo": "Não foi possível carregar a lista de avaliações",
                            "titulo": "Erro!"
                        },
                        "carregamento-cotacao": {
                            "corpo": "Não foi possível carregar a lista de vendedores desta cotação",
                            "titulo": "Erro!"
                        },
                        "carregamento-fornecedor": {
                            "corpo": "Não foi possível carregar a lista de fornecedores",
                            "titulo": "Erro!"
                        },
                        "pesquisa-invalida": {
                            "corpo": "Selecione um fornecedor/vendedor ou digite o código de uma cotação para realizar a pesquisa",
                            "titulo": "Erro!"
                        }
                    }
                },
                "vazio": "Nenhuma avaliação foi encontrada"
            },
            "selecione": {
                "fornecedor": "Todos fornecedores",
                "vendedor": "Todos vendedores"
            },
            "titulo": "Avaliação Vendedores"
        },
        "contestacoes": {
            "botoes": {
                "aprovar": "Aprovar"
            },
            "cabecalho": {
                "fornecedor": "Fornecedor",
                "oficina": "Oficina",
                "peca": "Peça",
                "reembolso": "Reembolso",
                "veiculo": "Veículo"
            },
            "confirm": "Deseja aprovar estas contestações?",
            "mensagens": {
                "erro": {
                    "aprovar": {
                        "corpo": "Não foi possível aprovar estas contestações",
                        "titulo": "Erro"
                    },
                    "carregamento": {
                        "corpo": "Não foi possível carregar as contestações pendentes",
                        "titulo": "Erro"
                    }
                },
                "sucesso": {
                    "aprovar": {
                        "corpo": "As contestações foram aprovadas",
                        "titulo": "Sucesso!"
                    }
                }
            },
            "titulo": "Lista de Contestações",
            "vazio": "Não existe nenhuma contestação pendente de aprovação"
        },
        "cotacoes": {
            "botoes": {
                "nao": "NÃO",
                "sim": "SIM"
            },
            "cabecalho": {
                "atualizar": "Atualizar Tela",
                "placeholder": "Filtre as cotações por código, marca, veículo..."
            },
            "colunas": {
                "marcar-completo": {
                    "corpo": "Deseja realmente enviar esta cotação para a próxima etapa?",
                    "titulo": "Concluir Trabalho",
                    "tooltip": "Marcar Como Completo"
                },
                "oficina": "Oficina",
                "pecas-respondidas": "Peças Respondidas / Total (Em BO)",
                "tem-pagantes": "Tem Pagantes?",
                "total-respostas": "Total de Respostas",
                "valor-estimado": "Vlr Estim",
                "veiculo": "Veículo"
            },
            "dados-cotacao": {
                "codigo": "Código",
                "comprador": {
                    "email": "E-mail",
                    "fones": "Fones",
                    "nome-oficina": "Comprador"
                },
                "data-criacao": "Criação",
                "editar": {
                    "link": "Editar Cotação"
                },
                "observacao": "Observações",
                "pecas": {
                    "bo": " (BO)",
                    "titulo": {
                        "encontradas": "Peças Encontradas",
                        "nao-encontradas": "Peças Não Encontradas"
                    }
                },
                "status": "Situação",
                "tem-erp": " (ERP)",
                "tipo-peca": {
                    "tipos": {
                        "alternativa": "A",
                        "genuina": "G",
                        "original": "O",
                        "sem-info": "Sem Info"
                    },
                    "titulo": "Tipo Peça"
                },
                "titulo": "Dados Cotação"
            },
            "mensagens": {
                "confirm": {
                    "excluir": "Deseja realmente excluir esta cotação?"
                },
                "erro": {
                    "adicionar-horas": {
                        "corpo": "Não foi possível adicionar horas a esta cotação",
                        "titulo": "Erro Desconhecido"
                    },
                    "atualizar": {
                        "corpo": "Não foi possível atualizar os dados desta cotação",
                        "titulo": "Erro Desconhecido"
                    },
                    "carregamento": {
                        "corpo": "Não foi possível carregar a sua lista de cotações",
                        "titulo": "Erro Desconhecido"
                    },
                    "carregamento-proxima": {
                        "corpo": "Não foi possível carregar a próxima cotação",
                        "titulo": "Erro Desconhecido"
                    },
                    "envio-link": {
                        "corpo": "Não foi possível enviar o link ao vendedor",
                        "titulo": "Erro Desconhecido"
                    },
                    "excluir": {
                        "corpo": "Não foi possível excluir esta cotação",
                        "titulo": "Erro Desconhecido"
                    },
                    "marcar-concluido": {
                        "corpo": "Não foi possível marcar como concluído",
                        "titulo": "Erro Desconhecido"
                    }
                },
                "nenhuma-cotacao-encontrada": "Não foi encontrada nenhuma cotação",
                "nenhum-vendedor-encontrado": "Não foi encontrado nenhum vendedor",
                "sucesso": {
                    "adicionar-horas": {
                        "corpo": "Horas adicionadas com sucesso",
                        "titulo": "Sucesso!"
                    },
                    "excluir": {
                        "corpo": "Cotação removida com sucesso",
                        "titulo": "Sucesso!"
                    },
                    "marcar-concluido-cotacao": {
                        "corpo": "Operação realizada com sucesso",
                        "titulo": "Cotação Enviada"
                    },
                    "marcar-concluido-vendedor": {
                        "corpo": "Operação realizada com sucesso",
                        "titulo": "Vendedor Concluído"
                    }
                }
            },
            "vendedores": {
                "adicionar-vendedor-externo": {
                    "campos": {
                        "company": {
                            "label": "Empresa",
                            "placeholder": "Selecione uma empresa"
                        },
                        "cnpj": "CNPJ",
                        "empresa": "Fornecedor",
                        "holding": {
                            "label": "Holding",
                            "placeholder": "Selecione uma holding"
                        },
                        "interno-externo": {
                            "cadastrado": "Cadastrado na {system}",
                            "nao-cadastrado": "Não Cadastrado na {system}"
                        },
                        "peca-nome": "Peça",
                        "usuario": {
                            "label": "Vendedor",
                            "placeholder": "Selecione um vendedor"
                        },
                        "vendedor": "Nome Vendedor",
                        "whatsapp": "Whats App",
                        "requerido": " (requerido)"
                    },
                    "campos-mensagens": {
                        "company": {
                            "obrigatorio": "Selecione a empresa"
                        },
                        "cnpj": {
                            "formato": "Formato do CNPJ inválido",
                            "obrigatorio": "Informe o CNPJ"
                        },
                        "empresa": {
                            "obrigatorio": "Informe o nome da empresa"
                        },
                        "holding": {
                            "obrigatorio": "Selecione a holding"
                        },
                        "vendedor": {
                            "obrigatorio": "Informe o nome do vendedor"
                        },
                        "usuario": {
                            "obrigatorio": "Selecione o vendedor"
                        },
                        "whatsapp": {
                            "formato": "Formato do telefone inválido",
                            "obrigatorio": "Informe o WhatsApp do vendedor"
                        }
                    },
                    "confirm-já-recebeu": "Este vendedor já recebeu o link, deseja reenviar?",
                    "enviar-link": "Enviar Link",
                    "erro-cadastro": {
                        "peca-faltante": "Pelo menos uma peça deve ser selecionada",
                        "titulo": "Opa! Alguma coisa não deu certo:",
                        "vendedor-ja-respondeu": {
                            "corpo": "Para refazer o convite é preciso apagar a resposta deste vendedor",
                            "titulo": "Vendedor Já Convidado e Com Resposta"
                        }
                    },
                    "link": "Adicionar Vendedor Externo",
                    "subtitulo": "Preencha os dados abaixo para adicionar um vendedor externo a cotação",
                    "titulo": "Adicionar Vendedor Externo"
                },
                "atualizar": {
                    "tooltip": "Atualizar Dados Vendedores",
                    "vendedores": "Alterar Vendedores"
                },
                "colunas": {
                    "titulo": {
                        "contato": "Entrar em Contato",
                        "participando": "Já Participando"
                    },
                    "fone-email": "Fones / E-mail",
                    "marcar-completo": {
                        "corpo": "Deseja realmente marcar este vendedor como concluído?",
                        "titulo": "Concluir Trabalho",
                        "tooltip": "Marcar Como Concluído"
                    },
                    "nome-empresa": "Vendedor (Empresa)"
                },
                "titulo": "Vendedores"
            },
            "modal": {
                "adicionar-complemento": {
                    "mensagens": {
                        "atencao": "Atenção",
                        "erro": {
                            "corpo": "Ocorreu um erro ao adicionar complemento a esta cotação",
                            "titulo": "Erro!"
                        },
                        "sucesso": {
                            "corpo": "Complemento(s) adicionado(s) com sucesso",
                            "titulo": "Sucesso!"
                        }
                    },
                    "pecas": {
                        "obrigatorio": "Ao menos uma peça deve ser cadastrada",
                        "tabela": {
                            "codigo": "Código",
                            "peca": {
                                "label": "Peça",
                                "obrigatorio": "O nome da peça é obrigatório",
                                "placeholder": "Descrição da peça"
                            },
                            "quantidade": {
                                "label": "Quantidade",
                                "obrigatorio": "O campo Quantidade é obrigatório e deve ser maior do que zero"
                            },
                            "vazia": "Nenhuma peça foi adicionada"
                        }
                    },
                    "titulo": "Adicionar Complementos"
                },
                "alterar-vendedores": {
                    "apagar-resposta": "Apagar Resposta",
                    "botao": {
                        "fechar": "Fechar",
                        "incluir": "Incluir",
                        "remover": "Remover"
                    },
                    "mensagens": {
                        "erro": {
                            "apagar-resposta": {
                                "corpo": "Não foi possível apagar esta resposta",
                                "titulo": "Operação Não Realizada"
                            },
                            "listar": {
                                "corpo": "Ocorreu um erro ao listar os vendedores desta cotação",
                                "titulo": "Operação Não Realizada"
                            },
                            "incluir-remover": {
                                "corpo": "Não foi possível alterar a participação deste vendedor",
                                "titulo": "Operação Não Realizada"
                            }
                        },
                        "sucesso": {
                            "apagar-resposta": {
                                "corpo": "Resposta do vendedor apagada com sucesso",
                                "titulo": "Sucesso!"
                            },
                            "incluir-remover": {
                                "corpo": "Participação do vendedor alterada com sucesso",
                                "titulo": "Sucesso!"
                            }
                        }
                    },
                    "titulo": "Atualização de Vendedores - Cotação #",
                    "veiculo": "Veículo"
                },
                "editar-cotacao": {
                    "botoes": {
                        "distribuir": "Re-Distribuir Auto Resposta",
                        "fechar": "Fechar",
                        "salvar": "Salvar",
                        "salvar-distribuir": "Salvar e Distribuir"
                    },
                    "dados": {
                        "ano": {
                            "label": "Ano"
                        },
                        "chassi": {
                            "label": "Chassi"
                        },
                        "marca": {
                            "label": "Marca",
                            "placeholder": "Selecione uma marca"
                        },
                        "placa": {
                            "label": "Placa"
                        },
                        "veiculo": {
                            "label": "Veículo",
                            "placeholder": "Digite o veículo e seu modelo"
                        }
                    },
                    "mensagens": {
                        "confirm": "Ao alterar o tipo de peça ou marca uma ou mais respostas podem ser perdidas. Deseja realmente continuar?",
                        "confirm-distribuir": "Deseja realmente re-distribuir esta cotação?",
                        "erro": {
                            "corpo": "Ocorreu um erro ao salvar esta cotação",
                            "titulo": "Operação Não Realizada"
                        },
                        "erro-distribuir": {
                            "corpo": "Ocorreu um erro ao re-distribuir esta cotação",
                            "titulo": "Operação Não Realizada"
                        },
                        "sucesso": {
                            "corpo": "Cotação alterada com sucesso",
                            "titulo": "Operação Realizada Com Sucesso"
                        },
                        "sucesso-distribuir": {
                            "corpo": "Cotação re-distribuída com sucesso",
                            "titulo": "Operação Realizada Com Sucesso"
                        }
                    },
                    "titulo": "Edição da Cotação #",
                    "titulo-distribuir": "Distribuir a Cotação #",
                    "validacao": {
                        "ano": {
                            "min_max": "O ano deve estar entre 1950 e ano que vem",
                            "obrigatorio": "Informe o ano"
                        },
                        "chassi": {
                            "min_max": "O chassi deve ter 17 caracteres",
                            "obrigatorio": "Informe o chassi"
                        },
                        "marca": "Informe a marca",
                        "placa": "Informe a placa",
                        "veiculo": "Informe o veículo"
                    }
                },
                "editar-peca": {
                    "botoes": {
                        "fechar": "Fechar",
                        "salvar": "Salvar"
                    },
                    "dados": {
                        "peca": {
                            "label": "Digite o código da peça"
                        }
                    },
                    "mensagens": {
                        "confirm": "Deseja realmente alterar o código da peça?",
                        "erro": {
                            "corpo": "Ocorreu um erro ao alterar o código desta peça",
                            "titulo": "Operação Não Realizada"
                        },
                        "sucesso": {
                            "corpo": "Código da peça alterado com sucesso",
                            "titulo": "Operação Realizada Com Sucesso"
                        }
                    },
                    "titulo": "Edição da Peça "
                }
            }
        },
        "diario": {
            "mensagens": {
                "erro": {
                    "carregamento": {
                        "corpo": "Não foi possível carregar as listas",
                        "titulo": "Erro!"
                    }
                }
            },
            "titulo": "Relatório Diário de Pedidos Pendentes e Atrasados",
            "subtitulo": "Veja os pedidos para serem entregues até amanhã e exclusões dos últimos 2 dias",
            "vazio": "Nenhuma cotação foi encontrada",
            "entradas": {
                "titulo": "Pedidos Confirmados Previstos para Entregar até Amanhã",
                "colunas": {
                    "delivery_day": "Entrega",
                    "quotation_id": "Pedido",
                    "vehicle": "Veículo",
                    "supplier_name": "Fornecedor",
                    "seller_name": "Vendedor",
                    "seller_phone_radio": "Fone / Whats App",
                    "repairer_name": "Oficina",
                    "buyer_name": "Comprador",
                    "buyer_phone_radio": "Fone / Whats App"
                }
            },
            "exclusoes": {
                "titulo": "Exclusões",
                "colunas": {
                    "creation_date": "Abertura",
                    "rejection_date": "Exclusão",
                    "reason": "Razão",
                    "vehicle_infos": "Veículo",
                    "repairer_name": "Oficina",
                    "buyer_name": "Comprador",
                    "buyer_phone_radio": "Fone / Whats App",
                    "reason_notes": "Conteúdo",
                    "duration": "Tempo Abertura"
                }
            }
        },
        "faturamento": {
            "cabecalho": {
                "atualizar": "Atualizar Tela",
                "titulo": "Faturamento"
            },
            "mensagens": {
                "confirm": {
                    "passo-1": "Deseja enviar os dados das oficinas da Central para o Superlogica?\n\rÚltimo envio: ",
                    "passo-2": "Deseja enviar os dados de fornecedores para o Superlogica?\n\rÚltimo envio: ",
                    "passo-3": "Deseja enviar os e-mails aos gestores?\n\rÚltimo envio: "
                },
                "erro": {
                    "carregar-logs": {
                        "corpo": "Houve um erro ao tentar carregar os dados da tela",
                        "titulo": "Erro!"
                    },
                    "obter-situacao-inicial": {
                        "corpo": "Houve um erro ao tentar carregar as últimas informações da tela",
                        "titulo": "Erro!"
                    },
                    "passo-1": {
                        "corpo": "Erro ao faturar oficinas central - Envio SL",
                        "titulo": "Erro!"
                    },
                    "passo-2": {
                        "corpo": "Erro ao faturar fornecedores - Envio SL",
                        "titulo": "Erro!"
                    },
                    "passo-3": {
                        "corpo": "Erro ao enviar os e-mails para os gestores",
                        "titulo": "Erro!"
                    }
                },
                "sucesso": {
                    "passo-1": {
                        "corpo": "Faturamento Oficinas Central - Superlogica",
                        "titulo": "Aguarde o fim do processamento"
                    },
                    "passo-2": {
                        "corpo": "Faturamento Fornecedores - Superlogica",
                        "titulo": "Aguarde o fim do processamento"
                    },
                    "passo-3": {
                        "corpo": "E-mails enviados para os gestores",
                        "titulo": "Aguarde o fim do processamento"
                    }
                }
            },
            "passos": {
                "data-vazia": "Sem Info",
                "log": {
                    "cabecalho": {
                        "data": "Data",
                        "info": "Informação",
                        "status": "Status"
                    },
                    "titulo": "Log Última Execução - ",
                    "vazio": "Não foi encontrado nenhuma informação de log"
                },
                "passo-1": {
                    "titulo": {
                        "passo": "Passo 1",
                        "nome": "Faturamento Oficinas Central - SL"
                    }
                },
                "passo-2": {
                    "titulo": {
                        "passo": "Passo 2",
                        "nome": "Faturamento Fornecedores - SL"
                    }
                },
                "passo-3": {
                    "titulo": {
                        "passo": "Passo 3",
                        "nome": "Enviar E-mails Para Gestores"
                    }
                },
                "ultima-execucao": "Data Última Execução:"
            }
        },
        "gerenciar-vendedores": {
            "titulo": "Gerenciar Vendedores",
            "nenhuma_oficina_encontrada": "Não foi encontrada nenhuma oficina associada a este fornecedor",
            "placeholder": "Encontre a oficina:",
            "selecione_fornecedor": "Selecione o Fornecedor:",
            "listar-empresas": "Listar Relações",
            "notFound": "Nenhum resultado encontrado",
            "baixar-csv": "Baixar CSV",
            "cabecalho": {
                "empresa": "Oficina",
                "cnpj": "CNPJ",
                "vendedor": "Vendedor Escolhido"
            },
            "cabecalho-csv": {
                "empresa": "Oficina",
                "cnpj": "CNPJ",
                "vendedor": "Vendedor Escolhido"
            },
            "mensagens": {
                "vazio": "Não foi encontrada nenhuma oficina associada a este fornecedor",
                "holding_is_billable": "Holding - Pagante",
                "holding_is_not_billable": "Holding - Não Pagante",
                "holding_is_net_free": "Holding - Rede Aberta",
                "sucesso": {
                    "titulo": "Sucesso",
                    "corpo": "Vendedor alterado com sucesso"
                },
                "excluir-associacao-falha": {
                    "titulo": "Erro",
                    "corpo": "Houve um erro ao tentar excluir esta associação"
                },
                "excluir-associacao-sucesso": {
                    "titulo": "Sucesso",
                    "corpo": "Associação excluída com sucesso"
                }
            }
        },
        "manutencao": {
            "limpar-tela-vendedor": {
                "botao-limpar": "Limpar Tela",
                "titulo": "Limpar Tela Vendedor",
                "buscar-vendedor": "Buscar Vendedor",
                "busque-vendedor": "Digite o id do vendedor e clique em buscar",
                "id-vendedor": "Id do vendedor",
                "mensagens": {
                    "confirm": {
                        "limpar-tela": "Deseja realmente limpar a tela deste vendedor?"
                    },
                    "erro": {
                        "carregamento": {
                            "corpo": "Não foi possível carregar os dados do vendedor",
                            "titulo": "Erro!"
                        },
                        "limpar-tela": {
                            "corpo": "Não foi possível limpar a tela deste vendedor",
                            "titulo": "Erro!"
                        }
                    },
                    "sucesso": {
                        "limpar-tela": {
                            "corpo": "Operação realizada com sucesso",
                            "titulo": "Sucesso!"
                        }
                    }
                },
                "nenhum-vendedor-encontrado": "Nenhum Vendedor Encontrado",
                "tabela": {
                    "fornecedor": "Fornecedor",
                    "nome": "Vendedor",
                    "seller-id": "Id",
                    "total-cotacoes": "Total Cotações"
                }
            },
            "oficina-sem-documentacao": {
                "mensagens": {
                    "erro": {
                        "carregamento": {
                            "corpo": "Não foi possível carregar as oficinas",
                            "titulo": "Erro!"
                        }
                    }
                },
                "tabela": {
                    "cnpj": "CNPJ",
                    "holding-id": "Holding Id",
                    "oficina": "Oficina",
                    "oficina-id": "Company Id"
                },
                "titulo": "Oficinas Sem Documentação",
                "vazio": "Nenhuma oficina encontarda"
            },
            "usuario": {
                "interno": {
                    "edicao": {
                        "campos": {
                            "ativo": {
                                "label": "Ativo"
                            },
                            "email": {
                                "label": "E-mail",
                                "formato-invalido": "Formato do e-mail inválido",
                                "obrigatorio": "Informe o e-mail",
                                "tamanho": "Máximo de 50 caracteres"
                            },
                            "login": {
                                "label": "Login",
                                "obrigatorio": "Informe o login",
                                "somente-letras": "Somente letras são permitidas",
                                "tamanho": "Máximo de 20 caracteres"
                            },
                            "nome": {
                                "label": "Nome",
                                "obrigatorio": "Informe o nome",
                                "somente-letras": "Somente letras são permitidas",
                                "tamanho": "Máximo de 50 caracteres"
                            },
                            "perfil": {
                                "central": "Central",
                                "faturamento": "Faturamento",
                                "label": "Perfil",
                                "obrigatorio": "Informe ao menos um tipo de perfil da central",
                                "obrigatorio-comprador": "Selecione ao menos um comprador abaixo",
                                "suporte": "Suporte"
                            },
                            "senha": {
                                "label": "Senha",
                                "obrigatorio": "Informe a senha",
                                "tamanho": "Máximo de 10 caracteres"
                            },
                            "whatsapp": {
                                "label": "WhatsApp",
                                "formato-invalido": "Formato do WhatsApp inválido",
                                "obrigatorio": "Informe o WhatsApp"
                            }
                        },
                        "mensagens": {
                            "erro": {
                                "salvar": {
                                    "corpo": "Não foi possível salvar os dados deste usuário",
                                    "titulo": "Erro!"
                                },
                                "salvar-mesmo-login": {
                                    "corpo": "Não foi possível salvar os dados deste usuário",
                                    "titulo": "Login Já Existente"
                                }
                            },
                            "sucesso": {
                                "salvar": {
                                    "corpo": "Dados do usuário salvos com sucesso",
                                    "titulo": "Sucesso!"
                                }
                            }
                        },
                        "perfil-central": {
                            "compradores": {
                                "cabecalho": {
                                    "comprador": "Comprador",
                                    "oficina": "Oficina"
                                }
                            },
                            "conversor": "Conversor",
                            "curador": "Curador",
                            "titulo": "Perfis Central"
                        }
                    },
                    "lista": {
                        "cabecalho": {
                            "editar": "Editar",
                            "id": "Id",
                            "nome": "Nome",
                            "perfil": "Perfil"
                        },
                        "mensagens": {
                            "erro": {
                                "carregamento": {
                                    "corpo": "Não foi possível carregar a lista de usuários",
                                    "titulo": "Erro!"
                                }
                            }
                        },
                        "vazio": "Nenhum usuário foi encontrado"
                    },
                    "novo": "Novo Usuário",
                    "titulo": "Usuários (Interno)"
                }
            },
            "voltar-cotacao": {
                "titulo": "Voltar Cotação",
                "buscar-cotacao": "Buscar Cotação",
                "mensagens": {
                    "confirm": {
                        "voltar": "Deseja realmente voltar esta cotação?"
                    },
                    "erro": {
                        "carregamento": {
                            "corpo": "Não foi possível carregar as cotações",
                            "titulo": "Erro!"
                        },
                        "voltar": {
                            "corpo": "Não foi possível voltar esta cotação",
                            "titulo": "Erro!"
                        }
                    },
                    "sucesso": {
                        "voltar": {
                            "corpo": "Operação realizada com sucesso",
                            "titulo": "Sucesso!"
                        }
                    }
                },
                "nenhuma-cotacao-encontrada": "Nenhuma Cotação Encontrada",
                "tabela": {
                    "data-criacao": "Criação",
                    "situacao": {
                        "excluida": "Excluída",
                        "expirada": "Expirada",
                        "titulo": "Situação"
                    },
                    "pecas": "Peças",
                    "quotation-id": "#",
                    "veiculo": "Veículo"
                }
            }
        },
        "pedidos": {
            "atrasados": {
                "colunas": {
                    "comprador": "Comprador",
                    "data-entrega": "Data Entrega",
                    "fornecedor": "Fornecedor",
                    "oficina": "Oficina",
                    "pedido": "Pedido",
                    "veiculo": "Veículo",
                    "vendedor": "Vendedor",
                    "vendedor-fone": "Fone / WhatsApp"
                },
                "titulo": "Pedidos Atrasados"
            },
            "mensagens": {
                "erro": {
                    "carregamento": {
                        "corpo": "Não foi possível carregar as listas",
                        "titulo": "Erro!"
                    }
                }
            },
            "pendentes": {
                "colunas": {
                    "comprador": "Comprador",
                    "data-compra": "Data Compra",
                    "fornecedor": "Fornecedor",
                    "oficina": "Oficina",
                    "pedido": "Pedido",
                    "veiculo": "Veículo",
                    "vendedor": "Vendedor",
                    "vendedor-fone": "Fone / WhatsApp"
                },
                "titulo": "Pedidos Pendentes de Confirmação"
            },
            "vazio": "Nenhum pedido foi encontrado"
        },
        "perfil": {
            "central": "Central",
            "popular": "Popular",
            "v8": "V8"
        }
    },
    "cadastro-cnpj":{
        "tabela":{
            "cabecalho": {
                "id": "Id",
                "nome-fantasia": "Nome Fantasia",
                "razao-social": "Razão Social",
                "CNPJ": "CNPJ",
                "editar": "Editar"
            },
            "vazio": "Nenhuma oficina foi encontrada"
        },
        "campos":{
            "nome": {
                "label": "Nome"
            },
            "cnpj": {
                "label": "CNPJ"
            },
            "razao-social": {
                "label": "Razão Social"
            },
            "oficina": {
                "label": "Oficina"
            },
            "manager-name": {
                "obrigatorio": "O nome do gestor é obrigatório",
                "somente-letras": "Somente letras são permitidas",
                "tamanho": "O tamanho máximo é de 50 caracteres"
            },
            "manager-whatsapp": {
                "formato-invalido":"Formato do Whats App inválido",
                "obrigatorio": "O Whats App do gestor é obrigatório"
            }
        },
        "botoes": {
            "adicionar-cnpj": "Adicionar CNPJ",
            "excluir-cnpj": "Excluir"
        },
        "novo": "Novo CNPJ",
        "filtro": "Filtre pelo nome da oficina",
        "mensagens": {
            "listar": {
                "erro": {
                    "corpo": "Não foi possível obter a lista de oficinas",
                    "titulo": "Erro!"
                }
            },
            "remover": {
                "confirm": "Desejar realmente remover os CNPJ's desta oficina?",
                " ": {
                    "corpo": "Não foi possível remover esta oficina",
                    "titulo": "Erro!"
                },
                "sucesso": {
                    "corpo": "Oficina removida com sucesso",
                    "titulo": "Sucesso!"
                }
            },
            "salvar": {
                "erro": {
                    "corpo": "Não foi possível atualizar os dados desta oficina",
                    "titulo": "Erro!"
                },
                "cnpj-existente": {
                    "corpo": "CNPJ já existente!",
                    "titulo": "Erro!"
                },
                "sucesso": {
                    "corpo": "Oficina atualizada com sucesso",
                    "titulo": "Sucesso!"
                }
            }
        },
        "titulo": "Cadastro de CNPJ - Oficina"
    }
}
